import React, { Component } from 'react';
import moment from 'moment';
import _ from 'lodash';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { isEmpty, get, isEqual } from 'lodash';
import { Form, Radio, Tab } from 'semantic-ui-react';
import { Tabs } from 'antd';
import asyncRoute from '../../../helpers/hoc/asyncRoute';
import { Menu, MenuItem, IconButton, Button as MUIButton, Popover, Accordion, AccordionSummary, AccordionDetails, colors } from '@material-ui/core';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import {
    getHomeRecommendListAction, getHomeRecentActivityAction, getHomeNotificationListAction, getSignInDataAction, dispatchPreSignInData, listAdvertiserAction, getPaymentRelatedAccessAction, getSubscribeTrialAction, getConfigurationDataAction, postRecchageSubscribeAction, logoutAction,
    getDataConfigAction, postHomeAccountPerformanceAction, postHomeCampaignPerformanceAction, getHomeAdvertiserListAction, getHomeDraftCampaignListAction, postHomeNotificationUpdateAction, getHomeScreenSigninAction, getReSignInDataAction, postTenantSupportedPaymentTypesAction, postTenantPaymentTypeAction, configAttributeAction,
    getUserProfileDetailsAction, postUserProfileDetailsAction, getTenantAccountAccessAction, getPreferenceListAllAction,
    postHomePreferenceAction,
    getDefaultPageAccess,
} from '../../../actions';
import routes from '../../../routes';
// import imgauth from '../../../assets/theme/img/illustrations/auth-login-illustration-dark.png';
import illustrationLight from "../../../assets/images/illustrations/auth-register-illustration-light.png";
import imgBg from '../../../assets/images/illustrations/bg-shape-image-light.png';
import infomoImg from '../../../assets/images/bekiLogo.png';
import Spinner from '../../../components/Spinner';
import { checkConnectionManagementAccess, encryptDataWithBlowfish, isApiCallSuccess, isPlatformManager, isTenantDemoAdvertiser } from '../../../selectors';
import TenantDropDown from '../../../components/elements/DropDown/TenantDropDown';
import { advertiserOptions, draftCampaignOptions, options } from './constant';
import "./signin.scss";
import Barchart from '../../../components/DashboardComponents/BarChart';
import { Switch, message } from 'antd'
import logo from '../../../assets/images/Sidenav_logo.png';
import { handleError, handleFieldError } from '../../../utils/form-validation';
import CryptoJS from 'crypto-js';
import Textarea from '../../../components/FormElements/Textarea';
import ToastModal from "../../../components/ToastModal";
import ErrorBoundary from '../../../components/ErrorBoundary';
import DraggableDropdown from '../../../components/DraggableComponent';
import { ms } from 'date-fns/locale';
import SetAccountsDefaultPage from '../../../components/DefaultPageTable';
import { withStyles } from '@material-ui/styles';
import { checkPermission } from '../../../utils/route-auth';
import { MODULE_PERMISSIONS, PERMISSION } from '../../../constants/permission';
import { ROUTE } from '../../../constants/route';
import { getDasbboardStaticData } from '../../../constants/demo/dashboardData';
import { accountWithMostRecommendation } from '../../../constants/demo/landingPageData';


const styles = (theme) => ({
    popover: {
        maxWidth: '600px', // Adjust the max width as needed
    },
    horizontalScroll: {
        overflowX: 'auto',
    },
    customAccordion: {
        backgroundColor: '#fff',
        // border: '1px solid #ccc',
        '&.Mui-expanded': {
            marginBottom: '0px', // Remove bottom margin when expanded
        },
    },
    customAccordionDetails: {
        // padding: theme.spacing(2),
        padding: 10
    },
    customAccordionSummary: {
        minHeight: '48px',
        backgroundColor: '#303890',
        color: "#fff",
        '&.Mui-expanded': {
            minHeight: '48px', // Override the min-height for expanded state
        },
    },
    customAccordionSummaryContent: {
        margin: '12px 0 !important', // Override the margin for both expanded and non-expanded states
        '&.Mui-expanded': {
            margin: '12px 0 !important', // Ensure the margin stays the same when expanded
        },
    },
    expandedAccordionDetails: {
        margin: '0px !important',
        padding: 0
    },
    customExpandIcon: {
        color: '#fff', // Change this to the desired color
    },
});

const AuthenticationCard = asyncRoute(() => import('../../../components/Card/AuthenticationCard'));
const Button = asyncRoute(() => import('../../../components/elements/Button'));
const AuthenticationBody = asyncRoute(() => import('../../../components/AuthenticationBody'));
// const HomeHeader = asyncRoute(() => import('../../../components/HomeHeader'));
const SideNav = asyncRoute(() => import('../../../components/SideNav'));
const Table = asyncRoute(() => import('../../../components/CustomTable'));
const HierarchyChart = asyncRoute(() => import('../../../components/HierarchyChart'));
const Modal = asyncRoute(() => import('../../../components/Modal'));
const Input = asyncRoute(() => import('../../../components/FormElements/Input'))

const { TabPane } = Tabs;

// Constants for local storage
// const ACCORDION_KEY = 'accordionSections';

const formFields = {
    name: {
        key: 'name',
        type: 'text',
        label: 'Name',
        required: true,
        placeholder: 'Enter Name',
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        tooltip: '<div> Name </div>',
        maxLength: 100,
        maxLengthMessage: 'maximum 100 characters allowed.',
    },
    email: {
        key: 'email',
        type: 'text',
        label: 'Email',
        placeholder: 'Enter Email',
        required: true,
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        maxLengthMessage: 'maximum 100 characters allowed.',
        pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,})+$/
    },
    contact: {
        key: 'contact',
        type: 'number',
        label: 'Contact Number',
        required: true,
        placeholder: 'Enter Contact Number',
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        tooltip: '<div> Tenant Name </div>',
        pattern: /^\d{7,14}(?:,\d{7,14})*$/,
        patternMessage: 'Minimum 7 and Maximum 14 Digit allowed'
    },
    message: {
        key: 'message',
        type: 'text',
        label: 'Message',
        required: true,
        requiredMessage: 'This field is required.',
        placeholder: 'Enter Message',
        displayLayout: 'col-md-12',
        tooltip: '<div> Address1 </div>',
    },

};

const userProfileFormFields = {
    name: {
        key: 'name',
        type: 'text',
        // label: 'Name',
        required: true,
        placeholder: 'Enter Name',
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        tooltip: '<div> Name </div>',
        maxLength: 100,
        maxLengthMessage: 'maximum 100 characters allowed.',
    },
    email: {
        key: 'email',
        type: 'text',
        // label: 'Email',
        placeholder: 'Enter Email',
        required: true,
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        maxLengthMessage: 'maximum 100 characters allowed.',
        pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,})+$/,
        patternMessage: 'Please enter a valid email'
    },
    otp: {
        key: 'otp',
        type: 'number',
        // label: 'OTP',
        required: true,
        placeholder: 'Enter OTP',
        requiredMessage: 'This field is required.',
        displayLayout: 'col-md-12',
        tooltip: '<div> OTP </div>',
        // pattern: /^\d{7,14}(?:,\d{7,14})*$/,
        // patternMessage: 'Minimum 7 and Maximum 14 Digit allowed'
    },
};

const changePasswordFormFields = {
    oldPassword: {
        key: 'oldPassword',
        type: 'password',
        label: 'Enter Old Password',
        required: true,
        placeholder: 'Password',
        requiredMessage: 'Password is required.',
        displayLayout: 'col-sm-12',
        pattern: /^(?=.*[A-Z])(?=(?:.*[a-z]){5,})(?=.*\d.*\d)(?=.*[@])[A-Za-z\d@]{8,}$/,
        patternMessage: `Your password must meet the following criteria:`,
        // patternMessage: 'Password contain at least five character two digit and one capital character.',
        // maxLength: 5,
        // maxLengthMessage: 'maximum 5 characters allowed.',
        spaceNotAllowed: true,
        labelLayout: 'col-sm-12'
    },
    password: {
        key: 'password',
        type: 'password',
        label: 'Enter New Password',
        required: true,
        placeholder: 'Password',
        requiredMessage: 'Password is required.',
        displayLayout: 'col-sm-12',
        pattern: /^(?=.*[A-Z])(?=(?:.*[a-z]){5,})(?=.*\d.*\d)(?=.*[@])[A-Za-z\d@]{8,}$/,
        patternMessage: `Your password must meet the following criteria:`,
        // patternMessage: 'Password contain at least five character two digit and one capital character.',
        // maxLength: 5,
        // maxLengthMessage: 'maximum 5 characters allowed.',
        spaceNotAllowed: true,
        labelLayout: 'col-sm-12'
    },
    confirmPw: {
        key: 'confirmPw',
        type: 'password',
        label: 'Confirm New Password',
        required: true,
        placeholder: 'Confirm New Password',
        requiredMessage: 'Confirm new password is required',
        displayLayout: 'col-sm-12',
        pattern: /^(?=.*[A-Z])(?=(?:.*[a-z]){5,})(?=.*\d.*\d)(?=.*[@])[A-Za-z\d@]{8,}$/,
        patternMessage: 'Your password must meet the following criteria:',
        // patternMessage: 'The Password Should Contain Six Letters Including One Capital Letter and Two Digits',
        // maxLength: 10,
        // maxLengthMessage: 'maximum 10 characters allowed.',
        spaceNotAllowed: true,
        labelLayout: 'col-sm-6',
        customError: false,
        customErrorMessage: "Password does not match"
    },

};


class SignIn extends Component {
    constructor(props) {
        super(props);

        // Load initial state from local storage
        // const storedAccordion = JSON.parse(localStorage.getItem(ACCORDION_KEY));
        // const initialAccordion = storedAccordion || [
        const initialAccordion = [
            { id: 'section1', title: 'My Top Performing Accounts and Campaigns', expanded: true, visible: true, view: "Collapsed" },
            { id: 'section2', title: 'Account with Most Recommendations', expanded: false, visible: true, view: "Collapsed" },
            { id: 'section3', title: 'Draft Campaigns', expanded: false, visible: true, view: "Collapsed" },
            { id: 'section4', title: 'Advertiser Section', expanded: false, visible: true, view: "Collapsed" },
            { id: "section5", title: "Notification", expanded: false, visible: false, view: "Collapsed" }
        ];

        this.oneTimeAutoSelect = sessionStorage.getItem('autoSelect');


        this.state = {
            anchorEl: null,
            accordionSections: initialAccordion,
            expandedAccordion: 'draggable', // State to manage the expanded accordion
            tenantId: '',
            parentTenantId: '',
            collapse: true,
            isSignInProceedDisabled: true,
            checkFlag: false,
            showSpinner: false,
            showSignInSelect: true,
            recentActivityData: [],
            notificationListData: [],
            recommendListData: {},
            recommendListDataArray: [],
            dataConfigRecoType: [],
            selectedDateRange: 'lastDay',
            displayMode: 'table', // Default to table mode
            accPerformanceListData: [],
            campaignPerformanceListData: [],
            accPerformanceLastDay: [],
            advertiserHomeListData: [],
            advertiserSectionListData: [],
            draftCampaignListData: [],
            draftMergeTenantArray: [],
            filterDraftCampaign: [],
            draftTenantDropDownWidth: '',
            selectedDraftTenant: '',
            draftTenantDropDown: [{ value: 0, key: "Agency" }, { value: 1, key: "Advertiser" }],
            isAgency: JSON.parse(sessionStorage.getItem('isAgency')) || false,
            displayAccountAccessMode: 'table', // Default to table mode
            uploadedImage: null,
            userProfileDetails: {
                name: '',
                email: '',
                otp: ''
            },
            base64Image: '',
            tempBase64Image: null,
            editName: false,
            editEmail: false,
            otpVisible: false,  // To control OTP field visibility
            otpStartTime: null, // To track OTP start time
            otpEndTime: null,   // To track OTP end time
            timer: null,        // Timer reference for countdown
            remainingTime: 0,   // Remaining time for OTP,
            accountAccessData: [],
            changePasswordForm: {},
            changePasswordTouched: {},
            changePasswordErrors: {},
            changePasswordSubmited: false,
            openAccountAccess: false,
            form: {},
            touched: {},
            errors: {},
            submited: false,
            enableToast: false,
            toastStatus: "",
            toastMsg: "",
            isDemoAdvertiser: false, // To check if tenant is Demo advertiser,
            demoStaticData: getDasbboardStaticData(moment(new Date().setDate(new Date().getDate())).format('YYYY-MM-DD')).campaignPerformanceViewStaticData
        };
        this.handleFormFieldChange = this.handleFormFieldChange.bind(this);
        this.handleSignInProceed = this.handleSignInProceed.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);

        this.handleTenantChange = this.handleTenantChange.bind(this);
        this.handleProfileClick = this.handleProfileClick.bind(this);
        this.handleImageUpload = this.handleImageUpload.bind(this);
        this.handleImageChange = this.handleImageChange.bind(this);
        this.handleEditToggle = this.handleEditToggle.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

    }

    // componentWillMount() {
    //     const { preSignInResponseList, preSignInState } = this.props;
    //     const { history, history: { location: { pathname = '' } } } = this.props;
    //     console.log("preSignInResponseList", preSignInResponseList)
    //     const currentTenant = preSignInState.tenantId;
    //     console.log("preSignInState", currentTenant)


    //     let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
    //     if (isEmpty(isAuthenticated) && preSignInResponseList && preSignInResponseList[0].tenantType == "Platform Manager") {
    //         // let acctype = preSignInResponseList.find((res) => ((res.accountType == 0) ? res : ''));
    //         // console.log("acctype",acctype);
    //         // debugger;
    //         this.setState({
    //             tenantId: preSignInResponseList[0].tenantId,
    //             tenantType: preSignInResponseList.tenantType,
    //             parentTenantId: preSignInResponseList.parentTenantId,
    //         }, async () => {
    //             await this.homeScreenSignIn();
    //         })
    //         // history.push(routes.containers.dashboard);
    //     }

    //     // else if (!isEmpty(isAuthenticated) && preSignInResponseList[0].tenantType == "Platform Manager") {
    //     //     message.error("Home :: Access Denied for Platform Manager")
    //     //     history.push(routes.containers.dashboard);
    //     // }

    //     else {
    //         let tenant = preSignInResponseList && preSignInResponseList.length > 0 && preSignInResponseList.find((res) => ((res.accountType == 1 || res.accountType == 0) ? res : ''))
    //         // debugger;
    //         this.setState({
    //             tenantId: tenant.tenantId,
    //             tenantType: tenant.tenantType,
    //             parentTenantId: tenant.parentTenantId,
    //         }, async () => {
    //             await this.homeScreenSignIn();
    //             // this.setState({showSpinner:false})
    //         });

    //         let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
    //         if (!isEmpty(isAuthenticated) && !pathname.includes('atd-home')) {
    //             // history.push(routes.containers.dashboard);
    //             // console.log("history", routes.containers.dashboard)
    //         }
    //         // else if (preSignInResponseList.length == 1) {

    //         //     this.setState({
    //         //         showSignInSelect: false,
    //         //         tenantId: preSignInResponseList[0].tenantId,
    //         //     }, () => {
    //         //         const isSignInProceedDisabled = this.checkSignInProceedDisabled();
    //         //         this.setState({
    //         //             isSignInProceedDisabled,
    //         //         }, async () => {
    //         //             await this.handleSignInProceed();
    //         //             // this.setState({showSpinner:false})
    //         //         });
    //         //     });
    //         // }
    //         else if (preSignInResponseList.length >= 1) {
    //             this.setState({ showSpinner: false })
    //         }
    //     }
    // }

    componentWillMount() {
        const { preSignInResponseList, preSignInState } = this.props;
        // Agenda: We check the current tenant and then set it's details to state
        // for rendering this page data
        if (preSignInResponseList && preSignInResponseList.length > 0) {
            const currentTenantId = preSignInState.tenantId;
            let currentTenantData;

            // when multiple tenant
            if (currentTenantId) {
                currentTenantData = preSignInResponseList.find((res) => ((res.tenantId == currentTenantId) ? res : ''))
            }

            if (currentTenantData && Object.keys(currentTenantData).length > 0) {
                this.setState({
                    tenantId: currentTenantData.tenantId,
                    tenantType: currentTenantData.tenantType,
                    parentTenantId: currentTenantData.parentTenantId,
                    showSpinner: false
                }, async () => {
                    await this.homeScreenSignIn();
                });
            }
        }
    }

    componentDidMount() {
        // Working: If sessionStorage.getItem('autoSelect')[oneTimeAutoSelect] is null (only in initial render) then execute
        // Reason: Using sessionStorage because we want to persist Auto Select flag
        if (this.oneTimeAutoSelect === null) {
            const filteredList = this.props.preSignInResponseList.filter(item => {
                if (item.tenantType === "Platform Manager") {
                    return true;
                }
                return !(item.tenantType === "DSP/Ad network" || item.tenantType === "Advertiser & DSP/Ad network" || item.tenantType === "Demo Agency")
            });

            if (filteredList.length === 1) {
                this.handleFormFieldChange({ target: { value: filteredList[0].tenantId } })
            }
        }

        this.oneTimeAutoSelect = false;
        sessionStorage.setItem('autoSelect', false);
    }

    homeScreenViewConditions(preSignInResponseList = []) {
        if (preSignInResponseList.length === 1) {

        }
        else {

        }
    }

    handleFormFieldChange(e) {
        const { preSignInResponseList } = this.props;
        // let tenant = preSignInResponseList.find((res) => e.target.value === ((res.accountType === 0) ? res.parentTenantName : `${res.parentTenantName}(${res.tenantName})`))
        let tenant = preSignInResponseList.find((res) => e.target.value == res.tenantId)
        this.setState({
            tenantId: tenant.tenantId,
            tenantType: tenant.tenantType,
            parentTenantId: tenant.parentTenantId,
        }, () => {
            const isSignInProceedDisabled = this.checkSignInProceedDisabled();
            this.setState({
                isSignInProceedDisabled,
            });
            this.handleSignInProceed()
        });
    }

    checkSignInProceedDisabled() {
        const {
            tenantId,
        } = this.state;
        return (!isEmpty(tenantId));
    }

    async getPaymentTypeConfigValues(tenantId, authToken, userId) {
        const { configAttributeAction } = this.props;
        let paymentTypesData = [];
        let { responseCode: { status = "" }, responseList } = await configAttributeAction({ tenantId, authToken, userId, type: 'PAYMENT_TYPE' });
        if (isApiCallSuccess(status) && responseList && responseList.length > 0) {
            paymentTypesData = responseList;
        }
        return paymentTypesData;
    }

    async checkPaymentTypeAndAssign(tenantId, authToken, userId) {
        const { postTenantSupportedPaymentTypesAction, postTenantPaymentTypeAction } = this.props;
        let payload = { tenantId };
        let paymentTypeValues = await this.getPaymentTypeConfigValues(tenantId, authToken, userId);
        const { responseCode: { status }, response } = await postTenantSupportedPaymentTypesAction({ tenantId, authToken, userId, payload });
        if (isApiCallSuccess(status) && response && Object.keys(response).length == 0) {
            let prePaidPaymentType = paymentTypeValues.find(item => item.value == "PRE_PAID");
            prePaidPaymentType = prePaidPaymentType && prePaidPaymentType.hasOwnProperty('key') ? prePaidPaymentType.key : '';
            let payload = {
                tenantId: tenantId,
                paymentType: {
                    creditAmount: null,
                    paymentMode: {
                        id: prePaidPaymentType
                    },
                    paymentCreditType: null
                }
            };
            const { responseCode: { status = '' } } = await postTenantPaymentTypeAction({ tenantId, authToken, userId, payload });
            if (isApiCallSuccess(status)) {
                console.log('Payment Type Mapped Successfully!');
            }
        };
    }

    async homeScreenSignIn(e) {
        if (e) {
            e.preventDefault();
        }
        const { preSignInState, history, history: { location: { pathname = '' } }, dispatchPreSignInData, getHomeScreenSigninAction, listAdvertiserAction, userId, getPaymentRelatedAccessAction, getSubscribeTrialAction, getConfigurationDataAction, postRecchageSubscribeAction } = this.props;
        const { tenantId, parentTenantId } = this.state;
        // console.log("tenantId", tenantId)
        let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));

        if (!pathname.includes('atd-home')) {

            dispatchPreSignInData({ ...preSignInState, tenantId, parentTenantId }).then(async () => {
                // let { responseCode: { status = '' } = {}, authToken = '' } = await getSignInDataAction({ ...preSignInState, tenantId }, history);
                let data = await encryptDataWithBlowfish({ ...preSignInState, tenantId });
                let { responseCode: { status = '' } = {}, authToken = '' } = await getHomeScreenSigninAction(data, history);
                // debugger;
                if (status === 'Success' && authToken) {

                    const { history } = this.props;
                    let isPlatFormData = JSON.parse(localStorage.getItem('PreSignInData'));


                    this.homeScreenApiCall(tenantId, authToken, userId);

                }
            })
        }
        else {
            const { authToken } = isAuthenticated;
            const { tenantIdVerified } = this.props;

            this.homeScreenApiCall(tenantIdVerified, authToken, userId);

        }

    }

    async handleSignInProceed(e) {
        if (e) {
            e.preventDefault();
        }
        const { preSignInState, history, dispatchPreSignInData, getSignInDataAction, listAdvertiserAction, userId, getDefaultPageAccess, getPaymentRelatedAccessAction, getSubscribeTrialAction, getConfigurationDataAction, postRecchageSubscribeAction } = this.props;
        const { tenantId, parentTenantId } = this.state;
        dispatchPreSignInData({ ...preSignInState, tenantId, parentTenantId }).then(async () => {
            // let { responseCode: { status = '' } = {}, authToken = '' } = await getSignInDataAction({ ...preSignInState, tenantId }, history);
            let data = await encryptDataWithBlowfish({ ...preSignInState, tenantId });
            let { responseCode: { status = '' } = {}, authToken = '' } = await getSignInDataAction(data, history);
            if (status === 'Success' && authToken) {
                localStorage.setItem('isSigningIn', 0);
                const { history } = this.props;
                let isPlatFormData = JSON.parse(localStorage.getItem('PreSignInData'));


                // this.homeScreenApiCall(tenantId, authToken, userId);
                const { responseCode: { status: defaultPageStatus }, responseObj: defaultPageResponse } = await getDefaultPageAccess({ tenantId, authToken, userId });

                if (isPlatFormData && isPlatFormData.responseCode &&
                    isPlatFormData.responseCode.status.toLowerCase() == "success"
                    && isPlatFormData.responseList.length > 0 && isPlatFormData.responseList[0] &&
                    isPlatFormData.responseList[0].tenantType !== "Platform Manager") {
                    await this.checkPaymentTypeAndAssign(tenantId, authToken, userId);
                }

                /*if (isPlatFormData && isPlatFormData.responseCode &&
                    isPlatFormData.responseCode.status.toLowerCase() == "success"
                    && isPlatFormData.responseList.length > 0 && isPlatFormData.responseList[0] &&
                    isPlatFormData.responseList[0].tenantType !== "Platform Manager") {
                    await this.checkPaymentTypeAndAssign(tenantId, authToken, userId);
                    const { responseCode: { status }, response } = await getPaymentRelatedAccessAction({ tenantId, authToken, userId });
                    if (status.toLowerCase() == "success") {
                        if (response && response.subscriptionDetails && response.subscriptionDetails.length == 0) {
                            try {
                                this.setState({ showSpinner: true });
                                const { responseCode: { status }, response } = await getSubscribeTrialAction({ tenantId, authToken, userId });
                                if (status.toLowerCase() == "success") {
                                    const payload = {
                                        planId: response && response.length > 0 && response[0].id,
                                        isAutoRechage: 0,
                                    }
                                    const { responseCode: { status, msg } } = await postRecchageSubscribeAction({ tenantId, authToken, userId, payload });
                                    if (status.toLowerCase() == "success") {
                                        this.setState({ showSpinner: false })
                                        // history.push(`/${routes.mainRoute}/${routes.containers.dashboard}`);
                                    }
                                    else {
                                        this.setState({ showSpinner: false })
                                    }
                                } else {
                                    this.setState({ showSpinner: false })
                                }
                            }
                            catch (err) {
                                this.setState({ showSpinner: false })
                            }
                        }
                        else {
                            this.setState({ showSpinner: false })
                        }
                    }
                    else {
                        this.setState({ showSpinner: false })
                    }
                }*/



                if (isPlatFormData && isPlatFormData.responseCode &&
                    isPlatFormData.responseCode.status.toLowerCase() == "success"
                    && isPlatFormData.responseList.length > 0 && isPlatFormData.responseList[0] &&
                    isPlatFormData.responseList[0].tenantType == "Platform Manager") {
                    history.push(routes.containers.dashboard);
                }
                else {
                    // const {
                    //     responseCode: { status = "" },
                    //     response,
                    // } = await listAdvertiserAction({ tenantId, authToken: authToken, userId });
                    // response.advertisersPlatforms.forEach((data, i) => {
                    //     data.platforms.length && data.platforms.forEach((platformsdata) => {
                    //         if (platformsdata.accountList && platformsdata.accountList.length == 0) {
                    //             this.setState({checkFlag: true})

                    //         } else  if (platformsdata.accountList && platformsdata.accountList.length > 0) {
                    //             this.setState({checkFlag: false})

                    //         }

                    //     })
                    // })
                    // let allPlatforms = response.advertisersPlatforms.map(entry => entry.platforms).flat();
                    // let isAccountListEmpty = allPlatforms && allPlatforms.length > 0 ? allPlatforms.every(element => element.accountList.length == 0) : false;
                    // history.push(routes.containers.dashboard);
                    // if (!isAccountListEmpty) {
                    // } else {
                    // if (defaultPageResponse.defaultPageName) {

                    //     switch (defaultPageResponse.defaultPageName) {
                    //         case 'ATD Dashboard':
                    //             history.push(routes.containers.dashboard);
                    //             break;
                    //         case 'ATD Campaign':
                    //             history.push(routes.containers.campaignList);
                    //             break;
                    //         case 'ATD Creative':
                    //             history.push(routes.containers.creative);
                    //             break;
                    //         case 'ATD Admin':
                    //             // history.push(routes.containers.admin);
                    //             let getUserPermissionList = ((localStorage.getItem('getUserPermissionList') && JSON.parse(localStorage.getItem('getUserPermissionList'))) || []);
                    //             let admin = MODULE_PERMISSIONS.ADMIN.find(a => getUserPermissionList.indexOf(a) > -1);
                    //             if (admin && ROUTE[admin]) {
                    //                 history.push(ROUTE[admin]);
                    //             }
                    //             break;
                    //         case 'ATD Payment Subscription':
                    //             let userPermissionListData = ((localStorage.getItem('getUserPermissionList') && JSON.parse(localStorage.getItem('getUserPermissionList'))) || []);
                    //             let payment = MODULE_PERMISSIONS.PAYMENT.find(a => userPermissionListData.indexOf(a) > -1);

                    //             // console.log("QWERTY", payment, ROUTE[payment]);
                    //             if (payment && ROUTE[payment]) {
                    //                 history.push(ROUTE[payment]);
                    //             }
                    //             break;
                    //         case 'ATD Fee Setting':
                    //             history.push(routes.containers.feeSettings);
                    //             break;
                    //         case 'ATD Optimiser':
                    //             history.push(routes.containers.optimizer);
                    //             break;
                    //         default:
                    //             history.push(routes.containers.dashboard);
                    //     }
                    // }
                    // else if (checkPermission({ permissions: [PERMISSION.DASHBOARD.VIEW] })) {
                    //     history.push(routes.containers.dashboard);
                    // }
                    // else if (checkPermission({ permissions: [PERMISSION.CREATIVE.CREATIVE.VIEW] })) {
                    //     history.push(routes.containers.creative);
                    // }
                    // else if (checkPermission({ permissions: [PERMISSION.OPTIMIZER.OPTIMIZER.VIEW] })) {
                    //     history.push(routes.containers.optimizer);
                    // }
                    // else if (checkPermission({ permissions: [PERMISSION.CAMPAIGN.CAMPAIGN.VIEW] })) {
                    //     history.push(routes.containers.campaignList);
                    // }
                    // else if (checkPermission({ permissions: [PERMISSION.FEESETTING.FEESETTING.VIEW] })) {
                    //     history.push(routes.containers.feeSettings);
                    // }
                    // else if (checkPermission({ permissions: [PERMISSION.ADMIN.VIEW] })) {
                    //     let getUserPermissionList = ((localStorage.getItem('getUserPermissionList') && JSON.parse(localStorage.getItem('getUserPermissionList'))) || []);
                    //     let admin = MODULE_PERMISSIONS.ADMIN.find(a => getUserPermissionList.indexOf(a) > -1);
                    //     if (admin && ROUTE[admin]) {
                    //         history.push(ROUTE[admin]);
                    //     }
                    // }
                    // else if (checkConnectionManagementAccess() && checkPermission({ permissions: [PERMISSION.ADMIN.CONNECTIONMANAGEMENT.VIEW] })) {
                    //     history.push(routes.containers.admin + '/' + routes.admin.connection.name);
                    // }


                    this.redirectBasedOnDefaultPage(defaultPageResponse.defaultPageName);

                    if (defaultPageResponse.defaultPageName) return;

                    if (this.checkAndRedirectPermission(PERMISSION.DASHBOARD.DASHBOARD.VIEW, routes.containers.dashboard)) return;
                    if (this.checkAndRedirectPermission(PERMISSION.CREATIVE.CREATIVE.VIEW, routes.containers.creative)) return;
                    if (this.checkAndRedirectPermission(PERMISSION.OPTIMIZER.OPTIMIZER.VIEW, routes.containers.optimizer)) return;
                    if (this.checkAndRedirectPermission(PERMISSION.CAMPAIGN.CAMPAIGN.VIEW, routes.containers.campaignList)) return;
                    if (this.checkAndRedirectPermission(PERMISSION.FEESETTING.FEESETTING.VIEW, routes.containers.feeSettings)) return;
                    if (this.checkAndRedirectPermission(PERMISSION.ADMIN.VIEW, this.getAdminRoute())) return;
                    if (this.checkAndRedirectPermission(PERMISSION.AUDIENCE.VIEW, routes.containers.audience)) return;
                    if (checkConnectionManagementAccess() && this.checkAndRedirectPermission(PERMISSION.ADMIN.CONNECTIONMANAGEMENT.VIEW, `${routes.containers.admin}/${routes.admin.connection.name}`)) return;

                }
            }
        });
    }


    redirectBasedOnDefaultPage(defaultPageName) {
        const { history, match } = this.props;
        switch (defaultPageName) {
            case 'ATD Dashboard':
                history.push(`${routes.containers.dashboard}`);
                break;
            case 'ATD Campaign':
                history.push(`${routes.containers.campaignList}`);
                break;
            case 'ATD Creative':
                history.push(`${routes.containers.creative}`);
                break;
            case 'ATD Admin':
                this.redirectToAdmin();
                break;
            case 'ATD Payment Subscription':
                this.redirectToPaymentSubscription();
                break;
            case 'ATD Fee Setting':
                history.push(`${routes.containers.feeSettings}`);
                break;
            case 'ATD Optimiser':
                history.push(`${routes.containers.optimizer}`);
                break;
            default:
                history.push(`${routes.containers.dashboard}`);
        }
    }

    // checkAndRedirectPermission(permission, route) {
    //     const { history, match } = this.props;
    //     if (checkPermission({ permissions: [permission] })) {
    //         // history.push(route);
    //         debugger;
    //         history.push(`${match.path}/${route}`);
    //         return true;
    //     }
    //     return false;
    // }


    checkAndRedirectPermission(permission, route) {
        const { history, match } = this.props;
        if (checkPermission({ permissions: [permission] })) {
            // Split the match.path by '/' and replace the last segment with the new route
            const newPath = match.path.split('/').slice(0, -1).concat(route).join('/');
            history.push(newPath);
            return true;
        }
        return false;
    }


    getAdminRoute() {
        let getUserPermissionList = localStorage.getItem('getUserPermissionList') ? JSON.parse(localStorage.getItem('getUserPermissionList')) : [];
        let admin = MODULE_PERMISSIONS.ADMIN.find(a => getUserPermissionList.indexOf(a) > -1);
        if (admin && ROUTE[admin]) {
            return ROUTE[admin];
        }
        return routes.containers.admin;
    }

    redirectToAdmin() {
        const { history } = this.props;
        let adminRoute = this.getAdminRoute();
        if (adminRoute) {
            history.push(adminRoute);
        }
    }

    redirectToPaymentSubscription() {
        const { history } = this.props;
        let userPermissionListData = localStorage.getItem('getUserPermissionList') ? JSON.parse(localStorage.getItem('getUserPermissionList')) : [];
        let payment = MODULE_PERMISSIONS.PAYMENT.find(a => userPermissionListData.indexOf(a) > -1);
        if (payment && ROUTE[payment]) {
            history.push(ROUTE[payment]);
        }
    }

    homeScreenApiCall = async (tenantId, authToken, userId) => {
        let requiredAuth = {
            tenantId, authToken, userId
        }
        this.setState({ requiredAuth });

        const {
            getHomeRecentActivityAction,
            getHomeNotificationListAction,
            getHomeRecommendListAction,
            preSignInResponseList,
            getDataConfigAction,
            postHomeAccountPerformanceAction,
            getHomeAdvertiserListAction,
            getHomeDraftCampaignListAction
        } = this.props;

        const { draftTenantDropDown } = this.state

        try {
            //--------USER PROFILE DETAILS---------------
            await this.userProfileDetails();


            // --------DATA CONFIG-------------------------
            await this.dataConfigApiFunction(tenantId, authToken, userId);
            await this.viewPreferenceApiCall();
            // console.log("Data Config State:", this.state.dataConfigRecoType);


            // --------RECENT ACTIVITY-------------------
            const { responseCode: { status: recentActivityStatus }, responseObj: recentActivityResponse } = await getHomeRecentActivityAction({ tenantId, authToken, userId });
            if (isApiCallSuccess(recentActivityStatus)) {

                const sortedRecentActivity = recentActivityResponse && recentActivityResponse.sort((a, b) => {
                    // Convert dates to Date objects for comparison
                    const dateA = new Date(a.cDate);
                    const dateB = new Date(b.cDate);

                    // Compare dates
                    return dateB - dateA;
                });

                // Update state with sorted data
                this.setState({ recentActivityData: sortedRecentActivity });

                // console.log("Recent Activity State:", this.state.recentActivityData);
            }


            // ------------DEMO ADVERTISER----------------
            const isDemoAdvertiser = isTenantDemoAdvertiser(tenantId);
            if (isDemoAdvertiser) {
                this.setState({ isDemoAdvertiser: true, recommendListDataArray: accountWithMostRecommendation })
                return;
            }


            // --------NOTIFICATION LIST------------------
            const { responseCode: { status: notificationStatus }, response: notificationResponse } = await getHomeNotificationListAction({ tenantId, authToken, userId });
            if (notificationStatus.toLowerCase() === "success") {
                this.setState({ notificationListData: notificationResponse });
            }
            // console.log("Notification List State:", this.state.notificationListData);


            // --------RECOMMEND LIST----------------------
            const { responseCode: { status: recommendStatus }, responseList: recommendResponse } = await getHomeRecommendListAction({ tenantId, authToken, userId });
            if (recommendStatus.toLowerCase() === "success") {
                // debugger;
                // if (recommendResponse && Object.keys(recommendResponse).length > 0) {
                //     const outputArray = this.processRecommendList(recommendResponse, preSignInResponseList);
                //     this.setState({ recommendListDataArray: outputArray });
                // }
                if (recommendResponse && recommendResponse.length > 0) {
                    this.setState({ recommendListDataArray: recommendResponse });
                }
                else {
                    console.log("No recommendation available");
                }
            } else {
                console.log("Failed to fetch recommendation data");
            }
            // console.log("Recommend List Data Array State:", this.state.recommendListDataArray);


            // --------ACCOUNT PERFORMANCE------------------
            await this.postHomeAccountPerformanceApiFunction(tenantId, authToken, userId, false);
            await this.postHomeCampaignPerformanceApiFunction(tenantId, authToken, userId, false);

            // console.log("Account Performance List State:", this.state.accPerformanceListData);


            // --------DRAFT CAMPAIGN LIST----------------------
            const { responseCode: { status: draftCampaignStatus }, response: draftCampaignResponse } = await getHomeDraftCampaignListAction({ tenantId, authToken, userId });
            if (draftCampaignStatus.toLowerCase() == "success") {
                if (draftCampaignResponse && draftCampaignResponse.length > 0) {

                    //GET DROPDOWN SELECT WIDTH
                    const text = draftTenantDropDown[0].key;
                    const draftTenantDropDownWidth = this.getTextWidth(text);

                    //FIND NAME on BASIS OF advId
                    const mergedArray = _.cloneDeep(draftCampaignResponse);
                    // Iterate over each campaign object and add advName based on advId
                    mergedArray.forEach(campaign => {
                        const adv = preSignInResponseList.find(item => item.tenantId == campaign.advId);
                        if (adv) {
                            campaign.advName = adv.tenantName; // tenant name you want to add
                        }
                    });

                    // SHOW DATA ACCORDING TO DRAFT DROPDOWN
                    const filteredDraftCampaignResponse = mergedArray.filter(item => item.tenantType == 0);

                    // Sort filteredDraftCampaignResponse by mDate and then by cDate if mDate is not present
                    filteredDraftCampaignResponse.sort((a, b) => {
                        const mDateA = new Date(a.mDate || a.cDate);
                        const mDateB = new Date(b.mDate || b.cDate);
                        return mDateB - mDateA;
                    });

                    this.setState({
                        draftMergeTenantArray: mergedArray,
                        filterDraftCampaign: filteredDraftCampaignResponse,
                        draftTenantDropDown,
                        draftTenantDropDownWidth: `${draftTenantDropDownWidth + 20}px`,
                    });
                } else {
                    console.log("No Draft Campaign available");
                }
            } else {
                console.log("Failed to fetch Draft Campaign data");
            }
            // console.log("Draft List Data Array State:", this.state.draftCampaignListData);


            // --------ADVERTISER LIST-----------------------
            // await this.setAdvertiserListData(tenantId, authToken, userId);

        } catch (error) {
            console.error("An error occurred:", error);
        }
    };


    viewPreferenceApiCall = async () => {
        try {
            const { getPreferenceListAllAction } = this.props;
            const { requiredAuth: { tenantId, authToken, userId }, dataConfigHomeScreenCard } = this.state;

            const { responseCode: { status = "", msg }, response } = await getPreferenceListAllAction({
                tenantId,
                authToken,
                userId,
            });
            if (isApiCallSuccess(status)) {
                // console.log("response", response)
                // console.log("dataConfigHomeScreenCard", this.state.dataConfigHomeScreenCard)
                const accordionSections = this.transformApiDataToAccordion(response, this.state.dataConfigHomeScreenCard);
                console.log("accordionSections", accordionSections)

                this.setState({ accordionSections });
            }
            else {
                message.error(msg)
            }
        } catch (err) {
            console.error("Error fetching user profile:", err);
        }
    };


    transformApiDataToAccordion = (apiData, dataConfigHomeScreenCard) => {
        // Map the API data to accordion sections
        const accordionSections = apiData.map((item, index) => {
            // Find the corresponding cardName from dataConfigHomeScreenCard
            const cardItem = dataConfigHomeScreenCard[0].list.find((card) => card.id === item.cardId);
            const title = cardItem ? cardItem.name : `Section ${item.id}`; // Use cardName if found, else fallback to a default title

            return {
                ...(item.id && { isFirstTime: false }), // Include id only if item.id exists
                id: item.id ? `section_${item.id}` : `section_${index}`,
                cardId: item.cardId,
                title: title ? title : item.title,
                expanded: item.cardProperties.includes("expanded"),
                visible: item.isActive ? true : false,
                view: item.cardProperties.includes("expanded") ? "Expanded" : "Collapsed",
                seq: item.seq, // Add the seq key
            };
        });

        // Sort the accordion sections based on the seq value
        const sortedSections = accordionSections.sort((a, b) => a.seq - b.seq);

        return sortedSections;
    };

    setAdvertiserListData = async (tenantId, authToken, userId) => {
        const { getHomeAdvertiserListAction } = this.props;
        const { accPerformanceListData, displayMode } = this.state;


        const { responseCode: { status: advertiserStatus }, response: advertiserResponse } = await getHomeAdvertiserListAction({ tenantId, authToken, userId });
        if (advertiserStatus.toLowerCase() === "success") {

            if (advertiserResponse && advertiserResponse.length > 0) {

                // const advertisersPayload = advertiserResponse.map(advertiser => ({ id: advertiser.advertiserId.toString() }));
                // console.log("accPerformanceListData", accPerformanceListData)

                // -----------FILTER advertiser?list=all ids- advertiser-section from account-performance?list=total ----------
                const filteredAccPerformanceList = accPerformanceListData.filter(accPerformance => {
                    const matchingAdvertiser = advertiserResponse.find(advertiser => advertiser.advertiserId == accPerformance.tenantId);
                    // console.log("matchingAdvertiser", matchingAdvertiser)
                    return matchingAdvertiser && matchingAdvertiser.advertiserId == accPerformance.tenantId;
                });

                // console.log("filteredAccPerformanceList", filteredAccPerformanceList)
                // console.log("accPerformanceListData", accPerformanceListData)

                // -----------Assign key activeCampaignCount into advertiser-section from account-performance?list=total ----------
                advertiserResponse.forEach(advertiser => {
                    const matchingAdvertiser = filteredAccPerformanceList.find(section => section.tenantId === advertiser.advertiserId);
                    if (matchingAdvertiser && advertiser.hasOwnProperty('activeCampaignCount')) {
                        matchingAdvertiser.activeCampaignCount = advertiser.activeCampaignCount;
                    }
                    if (matchingAdvertiser && advertiser.hasOwnProperty('availableCredit')) {
                        matchingAdvertiser.availableCredit = advertiser.availableCredit;
                    }
                    if (matchingAdvertiser && advertiser.hasOwnProperty('connectionCount')) {
                        matchingAdvertiser.connectionCount = advertiser.connectionCount;
                    }
                });

                // console.log("Filtered Account Performance List Data:", filteredAccPerformanceList);
                this.setState({
                    advertiserSectionListData: filteredAccPerformanceList,
                    advertiserHomeListData: advertiserResponse
                })

            } else {
                console.log("No advertiser available");
            }
        } else {
            console.log("Failed to fetch advertiser data");
        }
        // console.log("Advertiser Home List Data State:", this.state.advertiserHomeListData);
        // console.log("Advertiser Section List Data State:", this.state.advertiserSectionListData);
    }

    processRecommendList = (recommendResponse, preSignInResponseList) => {
        const { dataConfigRecoType } = this.state;

        //-----Filter Tenant List that are present as keys in recommendResponse
        const filteredTenantList = preSignInResponseList.filter(item => Object.keys(recommendResponse).includes(item.tenantId.toString()));
        const outputArray = [];

        //----Matching for tenant id in filteredTenantList--------
        filteredTenantList.forEach(tenant => {
            const tenantId = tenant.tenantId.toString();
            const recommendData = recommendResponse[tenantId];
            const matchingConfig = dataConfigRecoType.find(config => config.name === "RECO_TYPE");
            if (matchingConfig) {
                const businessAttr = matchingConfig.list.map(attrValue => {
                    const key = attrValue.id;
                    if (recommendData.hasOwnProperty(key)) {
                        return { [attrValue.name]: recommendData[key] };
                    }
                    return null;
                }).filter(Boolean);

                const outputObj = {
                    tenantName: tenant.tenantName,
                    tenantType: tenant.tenantType,
                    businessAttr: businessAttr
                };

                outputArray.push(outputObj);
            }
        });

        return outputArray;
    };

    getDateRangePayload = (dateRange) => {
        let endDate = moment();
        let startDate = moment();
        switch (dateRange) {
            case 'lastDay':
                startDate.subtract(1, 'day');
                endDate.subtract(1, 'day');
                break;
            case 'last7Days':
                startDate.subtract(7, 'days');
                endDate.subtract(1, 'day');
                break;
            case 'last15Days':
                startDate.subtract(15, 'days');
                endDate.subtract(1, 'day');
                break;
            case 'lastMonth':
                startDate.subtract(1, 'month');
                endDate.subtract(1, 'day');
                break;
            default:
                break;
        }
        return {
            sdate: startDate.format('YYYY-MM-DD'),
            edate: endDate.format('YYYY-MM-DD'),
        };
    };

    handleTabChange(dateRange) {
        // console.log("dateRange", dateRange); // Try logging data directly here
        const { requiredAuth: { tenantId, authToken, userId, isDemoAdvertiser } } = this.state;

        if (isDemoAdvertiser) return;

        this.setState({ selectedDateRange: dateRange }, () => {
            this.postHomeAccountPerformanceApiFunction(tenantId, authToken, userId, false);
            this.postHomeCampaignPerformanceApiFunction(tenantId, authToken, userId, false);
        });
    }

    toggleToGraph = () => {
        this.setState({ displayMode: 'graph' });
    };

    toggleToTable = () => {
        this.setState({ displayMode: 'table' });
    };


    postHomeAccountPerformanceApiFunction = async (tenantId, authToken, userId, advertisersPayload) => {
        const { selectedDateRange, } = this.state;
        const { postHomeAccountPerformanceAction } = this.props;
        const dateRangePayload = this.getDateRangePayload(selectedDateRange);

        const params = { list: "total" };
        const payload = {
            ...dateRangePayload,
            advertisers: advertisersPayload ? advertisersPayload : [],
        };
        try {
            const { responseCode: { status: accPerformanceStatus }, responseList: accPerformanceResponse } = await postHomeAccountPerformanceAction({ tenantId, authToken, userId, params, payload });
            if (accPerformanceStatus.toLowerCase() === "success") {
                const { advertiserHomeListData, advertiserSectionListData } = this.state;
                if (selectedDateRange == "lastDay") {
                    this.setState({
                        accPerformanceListData: accPerformanceResponse,
                        accPerformanceLastDay: accPerformanceResponse,
                    }, () => {
                        this.setAdvertiserListData(tenantId, authToken, userId);
                    });

                }
                else {
                    this.setState({ accPerformanceListData: accPerformanceResponse }, () => {
                        this.setAdvertiserListData(tenantId, authToken, userId);
                    });
                }
            }
            else if (accPerformanceStatus.toLowerCase() === "fail") {

                this.setState({
                    accPerformanceListData: [],
                });

            }
            // console.log("Updated State after Account Performance API:", this.state);
        } catch (error) {
            console.error("An error occurred:", error);
        }
    };

    postHomeCampaignPerformanceApiFunction = async (tenantId, authToken, userId, advertisersPayload) => {
        const { selectedDateRange, } = this.state;
        const { postHomeCampaignPerformanceAction } = this.props;
        const dateRangePayload = this.getDateRangePayload(selectedDateRange);

        const params = { list: "total" };
        const payload = {
            ...dateRangePayload,
            advertisers: advertisersPayload ? advertisersPayload : [],
        };

        try {
            const { responseCode: { status: campPerformanceStatus }, responseList: campaginPerformanceResponse } = await postHomeCampaignPerformanceAction({ tenantId, authToken, userId, params, payload });
            if (campPerformanceStatus.toLowerCase() === "success") {
                if (selectedDateRange == "lastDay") {
                    this.setState({
                        campaignPerformanceListData: campaginPerformanceResponse,
                    });
                }
                else {
                    this.setState({ campaignPerformanceListData: campaginPerformanceResponse }, () => {
                        // this.setAdvertiserListData(tenantId, authToken, userId);
                    });
                }
            }
            else if (campPerformanceStatus.toLowerCase() === "fail") {

                this.setState({
                    campaignPerformanceListData: [],
                });

            }
            // console.log("Updated State after Account Performance API:", this.state);
        } catch (error) {
            console.error("An error occurred:", error);
        }
    };

    dataConfigApiFunction = async (tenantId, authToken, userId) => {
        const { getDataConfigAction } = this.props;
        try {
            const { responseCode: { status = "" }, response } = await getDataConfigAction({ tenantId, authToken, userId });
            if (status === "Success") {
                const recoResponse = response.filter(item => item.name === "RECO_TYPE");
                const homeScreenCardResponse = response.filter(item => item.name === "HOMESCREEN_CARDS");
                this.setState({
                    dataConfigRecoType: recoResponse,
                    dataConfigHomeScreenCard: homeScreenCardResponse
                });
            }
            // console.log("Data Config State:", this.state.dataConfigHomeScreenCard);
        } catch (error) {
            console.error("An error occurred:", error);
        }
    };

    calculateTotalRecommendations = (item) => {
        let totalRecommendations = 0;
        item.businessAttr.forEach((attrObj) => {
            Object.values(attrObj).forEach((value) => {
                if (!isNaN(value)) {
                    totalRecommendations += value;
                }
            });
        });
        return totalRecommendations;
    };

    FreeTrailFunction = async (costDetailsConfigData, authToken, tenantId, userId) => {
        const { getSubscribeTrialAction, postRecchageSubscribeAction, history } = this.props
        const { responseCode: { status }, response } = await getSubscribeTrialAction({ tenantId, authToken, userId });
        let costConfigValue
        let CostingValueforPayload
        if (status.toLowerCase() == "success") {
            response && response[0].configData && response[0].configData.length && response[0].configData.forEach((dataRes) => {
                costConfigValue = costDetailsConfigData.find((cost) => cost.key == dataRes.catId);
                if (costConfigValue) {
                    CostingValueforPayload = costConfigValue
                }
            })

            const AmountCost = response && response[0].configData && response[0].configData.length && response[0].configData.find((dataID) => dataID.catId == CostingValueforPayload.key)
            const payload = {
                amount: +AmountCost.catValue,
                isAutoRechage: 0,
                planId: response && response[0].id,
                tenantId: tenantId,
            }
            const { responseCode: { status, msg } } = await postRecchageSubscribeAction({ tenantId, authToken, userId, payload });
            if (status.toLowerCase() == "success") {
                // history.push(`/${routes.mainRoute}/${routes.containers.dashboard}`);
            }

        }

    }

    handleLogout() {
        const AuthData = JSON.parse(localStorage.getItem('AuthData'));
        const { authToken } = AuthData;
        const { preSignInState, history, match, logoutAction } = this.props;
        preSignInState.tenantId = preSignInState.tenantId
        // console.log(this.props, "propsData")
        // console.log("preSignInState", preSignInState)
        // console.log("authToken", authToken)

        logoutAction(preSignInState, authToken).then(() => {
            history.push(routes.preSignIn);
        });
    }

    alertAction = async (item) => {
        const { postHomeNotificationUpdateAction } = this.props;
        const { requiredAuth: { tenantId, authToken, userId }, notificationListData } = this.state;

        // console.log("item", item);
        let payload = {
            notificationRequest: {
                notification: { id: item.id, action: 0 }
            }
        };
        let params = {
            addup: item.id
        };

        try {
            const { responseCode: { status }, responseList } = await postHomeNotificationUpdateAction({ tenantId, authToken, userId, params, payload });
            if (status.toLowerCase() === "success") {
                const updatedNotificationListData = notificationListData.map(notification => {
                    if (notification.id === item.id) {
                        return { ...notification, action: 0 };
                    }
                    return notification;
                });

                // console.log("responseList", responseList);
                // console.log("updatedNotificationListData", updatedNotificationListData);

                this.setState({ notificationListData: updatedNotificationListData });
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    }

    viewDetailsAction = async (item) => {
        const { postHomeNotificationUpdateAction, history } = this.props;
        const { requiredAuth: { tenantId, authToken, userId }, notificationListData } = this.state;

        // console.log("item", item);
        let payload = {
            notificationRequest: {
                notification: { id: item.id, action: 0 }
            }
        };
        let params = {
            addup: item.id
        };

        try {
            // const { responseCode: { status }, responseList } = await postHomeNotificationUpdateAction({ tenantId, authToken, userId, params, payload });
            // if (status.toLowerCase() === "success") {
            //     const updatedNotificationListData = notificationListData.map(notification => {
            //         if (notification.id === item.id) {
            //             return { ...notification, action: 0 };
            //         }
            //         return notification;
            //     });

            //     console.log("responseList", responseList);
            //     console.log("updatedNotificationListData", updatedNotificationListData);

            if (item.actionData.tenantId == tenantId) {
                this.setState({
                    // notificationListData: updatedNotificationListData,
                }, () => {
                    switch (item.actionData.featureId) {
                        case '0':
                            history.push(routes.containers.campaignList);
                            break;
                        case '1':
                            history.push(routes.containers.campaignList);
                            break;
                        case '2':
                            history.push(routes.containers.creative);
                            break;
                        case '3':
                            history.push(routes.containers.payment / routes.payment.billingHistory.name);
                            break;
                        case '4':
                            history.push(routes.containers.payment / routes.payment.invoice.name);
                            break;
                        case '5':
                            history.push(routes.containers.payment / routes.payment.billingHistory.name);
                            break;
                        case '6':
                            history.push(routes.containers.payment / routes.payment.subscription.name);
                            break;
                        default:
                            history.push(routes.containers.dashboard);
                            break;
                    }
                });
            }
            else {
                this.handleTenantChange(item)
                // }
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    }

    handleTenantChange(item) {
        const AuthData = JSON.parse(localStorage.getItem('AuthData'));
        const PreSignInState = JSON.parse(localStorage.getItem('PreSignInState'));
        const { authToken } = AuthData;
        const { actionData: { featureId, tenantId } } = item;
        const { parentTenantId } = this.state;

        // debugger;
        localStorage.removeItem("editId");
        const { getReSignInDataAction, preSignInState, dispatchPreSignInData, history, match, history: { location: { pathname = '' } } } = this.props;

        if (!pathname.includes('atd-home')) {
            try {
                //      getRoleAccessPermissions({ tenantId: preSignInState.tenantId, authToken: signInData.authToken, userId: preSignInData.userId });
                // dispatchAuthenticationDataAction({ preSignInState, signInData, preSignInData });
                // getConfigurationDataAction({ tenantId: preSignInState.tenantId, authToken: signInData.authToken, userId: preSignInData.userId });
                dispatchPreSignInData({ ...preSignInState, tenantId, parentTenantId }).then(async () => {
                    let data = await encryptDataWithBlowfish({ ...preSignInState, tenantId });
                    let { responseCode: { status = '' } = {}, authToken = '' } = await getHomeScreenSigninAction(data, history);
                    if (status == 'Success' && authToken) {
                        switch (featureId) {
                            case '0':
                                history.push(routes.containers.campaignList);
                                break;
                            case '1':
                                history.push(routes.containers.campaignList);
                                break;
                            case '2':
                                history.push(routes.containers.creative);
                                break;
                            case '3':
                                history.push(routes.containers.payment / routes.payment.billingHistory.name);
                                break;
                            case '4':
                                history.push(routes.containers.payment / routes.payment.invoice.name);
                                break;
                            case '5':
                                history.push(routes.containers.payment / routes.payment.billingHistory.name);
                                break;
                            case '6':
                                history.push(routes.containers.payment / routes.payment.subscription.name);
                                break;
                            default:
                                history.push(routes.containers.dashboard);
                                break;
                        }
                    }
                });
            } catch (error) {
                console.error("An error occurred:", error);
            }
        }
        else if (!isEmpty(preSignInState)) {
            try {
                dispatchPreSignInData({ ...preSignInState, tenantId }).then(async () => {
                    // debugger;
                    let data = await encryptDataWithBlowfish({ ...preSignInState, tenantId });
                    let { responseCode: { status = '' }, authToken = '' } = await getReSignInDataAction(data, AuthData.authToken);
                    if (status == 'Success' && authToken) {
                        // debugger;
                        switch (featureId) {
                            case '0':
                                history.push(routes.containers.campaignList);
                                break;
                            case '1':
                                history.push(routes.containers.campaignList);
                                break;
                            case '2':
                                history.push(routes.containers.creative);
                                break;
                            case '3':
                                history.push(routes.containers.payment / routes.payment.billingHistory.name);
                                break;
                            case '4':
                                history.push(routes.containers.payment / routes.payment.invoice.name);
                                break;
                            case '5':
                                history.push(routes.containers.payment / routes.payment.billingHistory.name);
                                break;
                            case '6':
                                history.push(routes.containers.payment / routes.payment.subscription.name);
                                break;
                            default:
                                history.push(routes.containers.dashboard);
                                break;
                        }
                        // CAMPAIGN 0,
                        // MANDATE 1,
                        // CREATIVE 2,
                        // TRANSACTION_HISTORY 3,
                        // INVOICE 4,
                        // PAYMENT 5,
                        // SUBSCRIPTION 6;

                        // if (pathname.includes('atd-home')) {
                        //     history.push(`${match.path}/${routes.containers.dashboard}`);
                        // }
                        // else {
                        //     setTimeout(() => {
                        //         window.location.reload();
                        //     }, 500);
                        // }
                    }
                });
            } catch (error) {
                console.error("An error occurred:", error);
            }
        }
        else {
            dispatchPreSignInData({ ...PreSignInState, tenantId }).then(async () => {
                let data = await encryptDataWithBlowfish({ ...preSignInState, tenantId });
                getReSignInDataAction(data, authToken);
                // getReSignInDataAction({ ...PreSignInState, tenantId }, authToken);
            });
        }
    }

    PerformanceTable = ({ dataSource, type }) => {
        // Sort the dataSource array by impressions or spend based on type
        if (type === 'Account') {
            dataSource.sort((a, b) => (b.impressions || 0) - (a.impressions || 0));
        } else if (type === 'Campaign') {
            dataSource.sort((a, b) => (b.spend || 0) - (a.spend || 0));
        }

        return (
            <>
                <h6 className="px-3 pt-2 mb-0 fw-bold">
                    {type === 'Account' ? 'Top Performing Accounts' : 'Top Performing Campaigns'}
                </h6>
                <div className="performance-table">
                    <div className="performance-table-header">
                        <div className="performance-table-heading">{" "}</div>
                        <div className="performance-table-heading">Impressions</div>
                        <div className="performance-table-heading">Clicks</div>
                        <div className="performance-table-heading">CTR(%)</div>
                        <div className="performance-table-heading">Spends</div>
                    </div>
                    {dataSource.length > 0 ? (
                        dataSource.map((item, index) => (
                            <div
                                className="performance-table-row"
                                key={index}
                                onClick={() => { this.redirectTenant(item.tenantId); }}
                            >
                                <div
                                    className="performance-table-cell performance-table-cell-name"
                                    title={item.tenantName || item.campaign}
                                >
                                    {item.tenantName || item.campaign}
                                </div>
                                <div className="performance-table-cell">{item.impressions}</div>
                                <div className="performance-table-cell">{item.clicks}</div>
                                <div className="performance-table-cell">{item.ctr}</div>
                                <div className="performance-table-cell">{item.spend.toFixed(2)}</div>
                            </div>
                        ))
                    ) : (
                        <div className="performance-table-row">
                            <div className="performance-table-cell" style={{ gridColumn: 'span 5', textAlign: 'center' }}>No data available</div>
                        </div>
                    )}
                </div>
            </>
        );
    };





    redirectTenant = async (tenantId) => {
        if (!tenantId || isPlatformManager()) return;
        this.setState({ tenantId }, this.handleSignInProceed);
    }




    renderContent = () => {
        const { accPerformanceListData, campaignPerformanceListData, displayMode, isDemoAdvertiser, demoStaticData, selectedDateRange } = this.state; // Assuming accPerformanceListData is in component state

        // If tenant is Demo advertiser
        if (isDemoAdvertiser) {
            let filteredDemoStaticData = demoStaticData;

            switch (selectedDateRange) {
                case 'lastDay':
                    filteredDemoStaticData = [demoStaticData[0]]
                    break;
                default: break;
            }

            let resultantDemoStaticData = filteredDemoStaticData.reduce((accu, current) => {
                accu.impressions += current.impressions;
                accu.clicks += current.clicks;
                accu.ctr += current.ctr;
                accu.spend += accu.spend;
                accu.tenantName = 'DI Adv'

                return accu;

            }, { ...demoStaticData[0] })

            const mappedData = [{
                name: resultantDemoStaticData.tenantName,
                impressions: resultantDemoStaticData.impressions,
                clicks: resultantDemoStaticData.clicks,
                ctr: resultantDemoStaticData.ctr
            }];

            const campaignMappedData = filteredDemoStaticData.map(({ campaign, impressions, clicks, ctr }) => ({
                name: campaign,
                impressions,
                clicks,
                ctr
            }));

            if (displayMode === 'table') {
                return <>
                    {
                        <this.PerformanceTable dataSource={[resultantDemoStaticData]} type={'Account'} />
                    }
                    {
                        <this.PerformanceTable dataSource={filteredDemoStaticData} type={'Campaign'} />
                    } </>
            } else if (displayMode === 'graph') {
                return <>
                    <div className='px-3'>
                        <h6 className="pt-2 mb-3 fw-bold">Top Performing Accounts</h6>
                        <Barchart data={mappedData || []} labelColor={["#3768BF", "#0B91B4", "#00AEEE"]} />
                    </div>

                    <div className='px-3'>
                        <h6 className="pt-2 mb-3 fw-bold">Top Performing Campaigns</h6>
                        <Barchart data={campaignMappedData || []} labelColor={["#3768BF", "#0B91B4", "#00AEEE"]} />
                    </div>
                </>

            }
            return;
        }

        const mappedData = accPerformanceListData && accPerformanceListData.length > 0 && accPerformanceListData.map(({ tenantName, impressions, clicks, ctr }) => ({
            name: tenantName,
            impressions,
            clicks,
            ctr
            // impressions: Math.floor(Math.random() * 6),
            // clicks: Math.floor(Math.random() * 6),
            // ctr: Math.floor(Math.random() * 6)
        }));

        const campaignMappedData = campaignPerformanceListData && campaignPerformanceListData.length > 0 && campaignPerformanceListData.map(({ campaign, impressions, clicks, ctr }) => ({
            name: campaign,
            impressions,
            clicks,
            ctr
            // impressions: Math.floor(Math.random() * 6),
            // clicks: Math.floor(Math.random() * 6),
            // ctr: Math.floor(Math.random() * 6)
        }));
        if (displayMode === 'table') {

            return <>
                {accPerformanceListData && accPerformanceListData.length > 0 &&
                    <this.PerformanceTable dataSource={accPerformanceListData} type={'Account'} />
                }
                {campaignPerformanceListData && campaignPerformanceListData.length > 0 &&
                    <this.PerformanceTable dataSource={campaignPerformanceListData} type={'Campaign'} />
                }
                {campaignPerformanceListData && campaignPerformanceListData.length == 0 &&
                    <div style={{ fontFamily: "Poppins", padding: 10 }}>Campaign Data Not Available</div>
                }
                {(accPerformanceListData && accPerformanceListData.length == 0) &&
                    <div style={{ fontFamily: "Poppins", padding: 10 }}>Account Data Not Available</div>
                }
            </>
        }
        else if (displayMode === 'graph') {
            return <>
                {mappedData.length > 0 ?
                    <div className='px-3'>
                        <h6 className="pt-2 mb-3 fw-bold">Top Performing Accounts</h6>
                        <Barchart data={mappedData || []} labelColor={["#3768BF", "#0B91B4", "#00AEEE"]} />
                    </div>
                    :
                    // <div style={{ fontFamily: "Poppins", padding: 10 }}>No Data Available for Top Performing Accounts </div>
                    <></>
                }

                {campaignMappedData.length > 0 ?
                    <div className='px-3'>
                        <h6 className="pt-2 mb-3 fw-bold">Top Performing Campaigns</h6>
                        <Barchart data={campaignMappedData || []} labelColor={["#3768BF", "#0B91B4", "#00AEEE"]} />
                    </div>
                    :
                    // <div style={{ fontFamily: "Poppins", padding: 10 }}>No Data Available for Top Performing Campaigns</div>
                    <></>
                }
                {(accPerformanceListData.length == 0 || campaignPerformanceListData.length == 0) &&
                    <div style={{ fontFamily: "Poppins", padding: 10 }}>No Data Available</div>
                }

            </>
        }
        else if (accPerformanceListData.length == 0 || campaignPerformanceListData.length == 0) {
            return <div style={{ fontFamily: "Poppins", padding: 10 }}>No Data Available</div>
        }

        return null;
    };

    // Helper function to get text width
    getTextWidth = (text) => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        context.font = getComputedStyle(document.body).font;
        const width = context.measureText(text).width > 50 ? context.measureText(text).width - 17 : context.measureText(text).width - 6;
        // console.log("width", width)
        return width;
    };

    draftTenantDropDownClick = (e) => {
        e.preventDefault();
        const { target: { value } } = e
        // console.log("value", value)
        const { draftTenantDropDown, draftMergeTenantArray } = this.state;
        const filteredDraftCampaignResponse = draftMergeTenantArray.filter(item => item.tenantType == value)
        const text = draftTenantDropDown.find(item => item.value == value).key;
        const draftTenantDropDownWidth = this.getTextWidth(text);

        this.setState({
            draftTenantDropDownWidth: `${draftTenantDropDownWidth + 20}px`,
            filterDraftCampaign: filteredDraftCampaignResponse,
            selectedDraftTenant: value
        })
    }

    // handleToggle = () => {
    //     this.setState(prevState => ({
    //         isAgency: !prevState.isAgency
    //     }));
    // };



    //----------------TO BE Shifted to another component START here-------------------


    changePasswordDisabled() {
        const { changePasswordForm } = this.state;
        let { valid } = handleError(changePasswordForm, changePasswordFormFields);
        return (isEmpty(changePasswordForm.password) || isEmpty(changePasswordForm.confirmPw) || !valid);
    }

    // async checkUserProfileInStorage() {
    //     const userProfileStorageData = sessionStorage.getItem('userProfileDetails');
    //     if (userProfileStorageData) {
    //         // If data exists, parse and set it in the component's state
    //         const userProfileDetails = JSON.parse(userProfileStorageData);
    //         this.setState({ userProfileDetails, base64Image: userProfileDetails.profilePic });
    //     } else {
    //         // If no data, fetch it from the API
    //         this.userProfileDetails();
    //     }
    // }

    userProfileDetails = async () => {
        try {
            const { getUserProfileDetailsAction } = this.props;
            const { requiredAuth: { tenantId, authToken, userId } } = this.state;
            // const preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
            // const AuthData = JSON.parse(localStorage.getItem('AuthData'));
            // const { authToken } = AuthData;
            const params = {
                getProfile: userId,
            };
            const { responseCode: { status = "", msg }, responseList } = await getUserProfileDetailsAction({
                tenantId,
                authToken,
                userId,
                params,
            });
            if (isApiCallSuccess(status)) {
                // sessionStorage.setItem("userProfileDetails", JSON.stringify(responseList[0]));
                this.setState({ userProfileDetails: responseList[0], base64Image: responseList[0].profilePic });
            }
            else {
                message.error(msg)
            }
        } catch (err) {
            console.error("Error fetching user profile:", err);
        }
    };


    handleProfileClick() {
        const { showLogout } = this.state;
        this.setState({
            showLogout: !showLogout,
        });
    }

    // handleLogout() {
    //     const AuthData = JSON.parse(localStorage.getItem('AuthData'));
    //     const { authToken } = AuthData;
    //     const { logoutAction, preSignInState, history, match } = this.props;
    //     // preSignInState.tenantId = preSignInState.tenantId 
    //     // console.log(this.props,"propsData")

    //     logoutAction(preSignInState, authToken).then(() => {
    //         // history.push(`${match.path}/${routes.preSignIn}`);
    //         history.push(`/atd/pre-signin`);
    //     });
    // }

    handleLogoClick = () => {
        const { history, match } = this.props;
        history.push(`${match.path}/${routes.containers.dashboard}`);
    }

    collapseToggle = (e) => {
        e.preventDefault();
        const { toggleSidebar, isCollapse } = this.props;
        window.Helpers.toggleCollapsed();
        toggleSidebar(isCollapse);
    }

    handleChange = (e) => {
        this.setState({ form: { ...this.state["form"], [e.target.name]: e.target.value } })
    }

    handleTouch = (e) => {
        let { touched, form, errors } = this.state;
        let { error } = handleFieldError(form[e.target.name], formFields[e.target.name]);
        errors[e.target.name] = error;
        touched[e.target.name] = true;
        this.setState({ touched, errors });
    };


    // ChangePassword

    handlePasswordChange = (e) => {
        this.setState({ changePasswordForm: { ...this.state["changePasswordForm"], [e.target.name]: e.target.value } })
    }

    handlePasswordCTouch = (e) => {
        let { changePasswordTouched, changePasswordForm, changePasswordErrors } = this.state;
        let { error } = handleFieldError(changePasswordForm[e.target.name], changePasswordFormFields[e.target.name]);
        changePasswordErrors[e.target.name] = error;
        changePasswordTouched[e.target.name] = true;
        this.setState({ changePasswordTouched, changePasswordErrors });
    };


    savePasswordAction = () => {
        const { changePasswordForm } = this.state
        let { changePasswordErrors, valid } = handleError(changePasswordForm, changePasswordFormFields)
        // console.log(valid)
        if (valid) {
            // console.log(changePasswordForm, "changePasswordForm")
            this.setState({ enableToast: true, confirmationMsg: "Please confirm if you'd like to proceed with this action.", toastMsg: "", toastStatus: "", method: 'contactSupport', });

        } else {

            alert("please first fill all fileds")
        }

    }

    handleSubmit = (e) => {

        const { form } = this.state;
        const { match: { params: { id } } } = this.props;
        let { errors, valid } = handleError(form, formFields);

        if (valid) {

            this.setState({ enableToast: true, confirmationMsg: "Please confirm if you'd like to proceed with this action.", toastMsg: "", toastStatus: "", method: 'contactSupport', contactData: form });

        } else {
            this.setState({ enableToast: true, toastMsg: "Please fill in the required fields ", toastStatus: "Fail" });
            this.setState({ errors: errors, submited: true });
        }
    }

    toast = (status, msg) => {
        this.setState({ enableToast: true, toastStatus: status, toastMsg: msg });
        return;
    }

    confirmationCallbackModel = (id) => {
        const { method } = this.state;

        this.setState({ enableToast: false }, () => {
            if (method == "contactSupport") {
                this.submitContactForm()
            }
            else if (method == "changePassword") {
                this.handleUpdateProfile("password")
            }
        });
    }

    handleToastStatus = (status) => {
        this.setState({ enableToast: status });
    }

    submitContactForm = async () => {
        const { openHelpModal, form, contactData } = this.state;

        const { supportAction, tenantId, authToken, userId, addTenantAction } = this.props;
        // let addParams = { action: 'update' };
        // console.log("form", form);
        const payload =
        {
            "name": form.name,
            "email_id": form.email,
            "mobile_num": form.contact,
            "subject": "Contact Us",
            "message": form.message,
            "isEmail": 1
        }

        const {
            responseCode: { status = "", msg },
            responseList,
        } = (await supportAction({ tenantId, authToken, userId, payload })) || {};
        if (status.toLowerCase() == "success") {
            // this.toast(status, msg, "contactSupport");
            this.setState({ openHelpModal: !openHelpModal, enabletoastify: true, toastifyMsg: msg }, () => {
                setTimeout(() => {
                    this.setState({ enabletoastify: false })
                }, 4000)
            })
        }
    }



    setForm = async () => {
        const { openHelpModal } = this.state;

        this.setState({})
        const preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));

        this.setState({
            form: {
                ...this.state.form,
                name: preSignInData.username,
                email: preSignInData.userEmail,
                contact: preSignInData.userContact,
            },
            openHelpModal: !openHelpModal
        })

    }

    handleToggle = () => {
        this.setState(
            (prevState) => ({ isAgency: !prevState.isAgency }),
            () => {
                const { preSignInResponseList } = this.props;
                const preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
                const { responseList } = preSignInData;
                const { isAgency } = this.state;
                sessionStorage.setItem('advertiserData', JSON.stringify({}));
                // Filter the responseList based on the isAgency flag
                const filteredList = responseList.filter(item =>
                    isAgency ? item.tenantType === "DSP/Ad network" || item.tenantType === "Advertiser & DSP/Ad network" : true
                );
                // const value = filteredList[0].tenantName;
                // this.handleTenantChange({ target: { value: value } });

                //----------------Stop resignin on toggle----------------
                const tenantId = '';
                // Pass the empty string as tenantId to TenantDropDown
                this.setState({ tenantId: tenantId });

                // auto select on single tenant and swithing tenant type
                if (isAgency) {
                    const filteredList = preSignInResponseList.filter(item => {
                        return item.tenantType === "DSP/Ad network" || item.tenantType === "Advertiser & DSP/Ad network" || item.tenantType === "Demo Agency"
                    });

                    if (filteredList.length === 1) {
                        this.handleFormFieldChange({ target: { value: filteredList[0].tenantId } })
                    }
                }
                else {
                    const filteredList = preSignInResponseList.filter(item => {
                        if (item.tenantType === "Platform Manager") {
                            return true;
                        }
                        return !(item.tenantType === "DSP/Ad network" || item.tenantType === "Advertiser & DSP/Ad network" || item.tenantType === "Demo Agency")
                    });

                    if (filteredList.length === 1) {
                        this.handleFormFieldChange({ target: { value: filteredList[0].tenantId } })
                    }
                }
            }
        );
    };


    formInitialize = () => {
        // let { changePasswordForm, changePasswordErrors } = initializeForm(changePasswordFormFields);
        // this.setState({changePasswordForm})

        let changePasswordForm = {};
        let changePasswordErrors = {};
        _.each(_.keys(changePasswordFormFields), function (key) {
            changePasswordForm[key] = changePasswordFormFields[key] ? changePasswordFormFields[key].defaultValue || '' : '';
            changePasswordErrors[key] = {};
        });
        // return { form, errors };
        this.setState({ changePasswordForm, changePasswordErrors })
    };

    changePasswordAction = () => {
        this.setState({ openChangePassword: true }, () => {
            this.formInitialize()

        })
    }

    handleAccountAccess = () => {
        this.setState({ openAccountAccess: true }, () => {
            this.getAccountAccess();
        })

    }


    toggleAccountAccessGraph = () => {
        this.setState({ displayAccountAccessMode: 'graph' }, () => {
            // If switching to graph, scroll the chart to the center
            console.log("orgChartRef", this.orgChartRef)
            if (this.orgChartRef) {
                // this.orgChartRef.scrollToCenter();
            }
        });
    };

    toggleAccountAccessTable = () => {
        this.setState({ displayAccountAccessMode: 'table' });
    };

    renderAccountAccess = () => {
        const { accountAccessData, displayAccountAccessMode } = this.state; // Assuming accPerformanceListData is in component state

        const accountAccessoptions = {
            columns: [
                { id: 1, name: '', label: '', sortable: false, },
                { id: 2, name: 'tenantName', label: 'Account', sortable: false, type: 'string', component: (row) => <div title={row.tenantName}>{row.parentName && row.level != 1 ? `${row.tenantName} (${row.parentName})` : row.tenantName}</div> },
                { id: 3, name: 'roleName', label: 'Role', sortable: false, type: 'string', },
            ],
            keyCol: 'ioNo',
            actionName: 'ACTIONS',
            actions: [
                {
                    type: 'edit',
                    text: '',
                    icon: 'ti ti-pencil color-beki',
                    tooltip: 'Edit',
                    iconType: 'new'
                },
            ],
            recActive: false,
            actionsThead: false,
            sortable: true,
            dateType: true,
            defaultSortParams: {
                sortBy: 'txnDateTime',
                sortOrder: 'desc'
            },
            paging: true,
            defaultPagingParams: {
                pageSize: 10
            }
        };

        const groupedByParent = accountAccessData && accountAccessData.reduce((acc, item) => {
            const parentName = item.parentName;
            if (!acc[parentName]) {
                acc[parentName] = [];
            }
            acc[parentName].push(item);
            return acc;
        }, {});
        // console.log("groupedByParent", groupedByParent)

        // Recursive function to build the tree structure
        const buildTree = (name) => {
            const children = groupedByParent[name] || [];
            // Find the first item in the children that matches the current name to get the roleName
            const currentItem = accountAccessData && accountAccessData.find((item) => item.tenantName === name);
            // console.log("currentItem", currentItem)
            const roleName = currentItem ? currentItem.roleName : 'User'; // Handle case where roleName isn't found
            // console.log("roleName", roleName)
            return {
                name: name,
                roleName: roleName, // Add the roleName here
                children: children.map((child) => buildTree(child.tenantName)), // Recursively build children
            };
        };

        // Validate preSignInData before accessing properties
        const preSignInData = JSON.parse(localStorage.getItem('PreSignInData')) || {};
        const { username = 'Unknown' } = preSignInData; // Default to 'Unknown' if not defined

        const rootName = username || 'DefaultRoot'; // Provide a default if username is undefined
        const orgTree = buildTree(rootName); // Build the organizational tree

        // console.log("orgTree", orgTree)

        if (displayAccountAccessMode === 'table') {
            return <div className=" mb-3 campaign-list-adj table-responsive">
                <Table
                    options={accountAccessoptions}
                    data={accountAccessData}
                />
            </div>

        }
        else if (displayAccountAccessMode === 'graph') {
            // return <HierarchyChart orgTree={orgTree} />
            return <HierarchyChart orgTree={orgTree} ref={(ref) => (this.orgChartRef = ref)} />;

        }


        return null;
    };

    // This method is triggered when a file is uploaded
    handleImageChange(event) {
        const file = event.target.files[0]; // Get the first file
        if (file) {
            this.setState({ uploadedImage: file });
            this.handleImageUpload(file);
        }
    }

    // This method converts the image to Base64 and sets it in the state
    handleImageUpload(file) {
        const reader = new FileReader();

        reader.onloadend = () => {
            this.setState({
                tempBase64Image: reader.result,
            }, () => {
                this.handleUpdateProfile("editImage");
            });
        };

        reader.readAsDataURL(file); // Start reading the file to Base64
    }

    triggerFileInput() {
        document.getElementById('fileInput').click();
    }

    handleEditToggle(field) {
        this.setState((prevState) => ({
            [field]: !prevState[field], // Toggle the edit state for the field
        }));
    }

    handleInputChange(event, fieldName) {
        const { value } = event.target;
        this.setState((prevState) => ({
            userProfileDetails: {
                ...prevState.userProfileDetails,
                [fieldName]: value,
            },
        }));
    }

    handleDetailsTouch = (e) => {
        let { touched, userProfileDetails, errors } = this.state;
        let { error } = handleFieldError(userProfileDetails[e.target.name], userProfileFormFields[e.target.name]);
        errors[e.target.name] = error;
        touched[e.target.name] = true;
        this.setState({ touched, errors });
    };


    async handleUpdateProfile(field) {

        try {
            const { postUserProfileDetailsAction } = this.props;
            const { requiredAuth: { tenantId, authToken, userId } } = this.state;
            const { userProfileDetails, base64Image, tempBase64Image, changePasswordForm } = this.state;
            // const preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
            // const AuthData = JSON.parse(localStorage.getItem('AuthData'));
            // const { authToken } = AuthData;
            let newPassword = CryptoJS.MD5(changePasswordForm.password).toString();
            // newPassword = encryptDataWithBlowfish(newPassword, 'string');

            let oldPassword = CryptoJS.MD5(changePasswordForm.oldPassword).toString();
            // oldPassword = encryptDataWithBlowfish(oldPassword, 'string');
            // Create the payload based on the field being updated
            let payload = {};
            if (field == "editEmail") {
                payload.newEmail = userProfileDetails.email;
            } else if (field == "editName") {
                payload.name = userProfileDetails.name;
            } else if (field == "editImage") {
                payload.profilePic = tempBase64Image;
            } else if (field == "otp") {
                payload.newEmail = userProfileDetails.email;
                payload.OTP = userProfileDetails.otp;
            } else if (field == "password") {
                payload.newPassword = newPassword;
                payload.oldPassword = oldPassword;
            }

            const params = {
                updateProfile: userId,
            };

            const {
                responseCode: { status = "", msg }, response
            } = await postUserProfileDetailsAction({ tenantId, authToken, userId, payload, params });

            if (isApiCallSuccess(status)) {
                if (field == "editImage") {
                    this.setState({
                        base64Image: tempBase64Image,
                        tempBase64Image: null,
                    });
                }
                else if (field == "editEmail") {
                    // const { otpStartTime, otpEndTime } = response;  // API response has these fields
                    const { startTime, endTime } = response;

                    // Start OTP verification process
                    this.setState({
                        otpVisible: true,
                        otpStartTime: startTime,
                        otpEndTime: endTime,
                        remainingTime: endTime * 1000 - Date.now(), // Calculate remaining time in milliseconds
                    });

                    // Start the timer
                    this.startOtpTimer();
                    message.success(msg)
                }
                else if (field == "otp") {
                    message.success(msg)
                    this.setState({ otpVisible: false, editEmail: false, })
                }
                else if (field == "password") {
                    message.success(msg)
                    this.setState({ openChangePassword: false })
                    this.handleLogout();
                }
                else {
                    message.success(msg)
                    this.handleEditToggle(field)
                }
            }
            else {
                message.error(msg)
                console.error("Failed to update profile:", msg);
                this.setState({
                    tempBase64Image: null, // Clear the temporary image on failure
                });
            }
        } catch (error) {
            console.error("Error updating user profile:", error);
            this.setState({
                tempBase64Image: null, // Clear the temporary image on failure
            });
        }
    }


    startOtpTimer() {
        const interval = setInterval(() => {
            const { otpEndTime } = this.state;
            const remainingTime = otpEndTime * 1000 - Date.now();

            if (remainingTime <= 0) {
                clearInterval(this.state.timer);
                this.setState({ otpVisible: false }); // Hide OTP field when timer expires
            } else {
                this.setState({ remainingTime });
            }
        }, 1000);

        this.setState({ timer: interval });
    }

    // Convert milliseconds to MM:SS format
    formatTime = (milliseconds) => {
        const totalSeconds = Math.floor(milliseconds / 1000);
        const minutes = Math.floor(totalSeconds / 60); // Whole minutes
        const seconds = totalSeconds % 60; // Remaining seconds
        const formattedMinutes = minutes.toString().padStart(2, '0'); // Ensure 2 digits for minutes
        const formattedSeconds = seconds.toString().padStart(2, '0'); // Ensure 2 digits for seconds
        return `${formattedMinutes}:${formattedSeconds}`;
    };


    async getAccountAccess() {

        try {
            const { getTenantAccountAccessAction } = this.props;
            const { requiredAuth: { tenantId, authToken, userId } } = this.state;
            // const { userProfileDetails, base64Image, tempBase64Image } = this.state;
            // const preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
            // const AuthData = JSON.parse(localStorage.getItem('AuthData'));
            // const { authToken } = AuthData;

            const params = {
                tenantHierarchy: userId,
            };

            const {
                responseCode: { status = "", msg }, responseList
            } = await getTenantAccountAccessAction({ tenantId, authToken, userId: userId, params });

            if (isApiCallSuccess(status)) {
                this.setState({ accountAccessData: responseList })
                message.success(msg)
            }
            else {
                message.error(msg)
                console.error("Failed to update profile:", msg);
                this.setState({
                    tempBase64Image: null, // Clear the temporary image on failure
                });
            }
        } catch (error) {
            console.error("Error updating user profile:", error);
            this.setState({
                tempBase64Image: null, // Clear the temporary image on failure
            });
        }
    }


    handleResetSubmit = (e) => {
        e.preventDefault();
        const { changePasswordForm } = this.state;
        let { errors, valid } = handleError(changePasswordForm, changePasswordFormFields);
        const { confirmPw, password } = changePasswordForm;
        if (valid) {
            if (password != confirmPw) {
                // let info = { action: { confirmationMessage: 'Password and confirm password should be same.', type: 'error' } }
                // this.toggleModal(info)
                // this.setState({ enableToast: true, toastMsg: "Password and Confirm Password should be same.", toastStatus: "Fail", method: 'Save' });
                this.setState({ enableToast: true, toastMsg: "Make sure the entered password matches the one you provided above", toastStatus: "Fail", method: 'changePassword' });
                return false;
            } else {
                // this.submitForm()
                this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes.", toastMsg: "", toastStatus: "", method: 'changePassword' });

            }
        } else {
            this.setState({ errors: errors, submited: true });
        }
    }

    async submitForm() {
        const { location, changePasswordAction } = this.props;
        const { changePasswordForm } = this.state;
        let search = location.search;
        const params = new URLSearchParams(search);
        const rp = params.get('rp');
        // const authUser = params.get('uid');
        // let password = changePasswordForm.password
        let password = CryptoJS.MD5(changePasswordForm.password).toString();
        password = encryptDataWithBlowfish(password, 'string');

        const { responseCode: { status = '', msg = '' } } = await postUserProfileDetailsAction({ password, rp })
        // const { responeCode: { status } } = await changePasswordAction({ password, rp, authUser })
        if (status == 'Success') {
            // let successfullyMessage = { action: { confirmationMessage: 'Successfully change password.', type: 'alert' } }
            // this.setState({ confirmationOpen: false, changePasswordForm: {}, errors: {} }, () => {
            //     this.toggleModal(successfullyMessage);
            // })
            this.toast(status, 'Your password has been configured successfully, Please continue to Login.')
            return;
        } else {
            // let info = { action: { confirmationMessage: 'Error occurs', type: 'error' } }
            this.setState({ enableToast: true, toastMsg: "Error occurs", toastStatus: "Fail", method: 'Save' });

            // this.toggleModal(info);
        }
    }

    handleChangePassword = (e) => {
        let { changePasswordTouched, changePasswordForm, changePasswordErrors } = this.state;

        let { value, name } = e.target;
        changePasswordForm[name] = value;
        // console.log("value", value)

        // Check if old password and new password are the same
        if (name === 'password' || name === 'oldPassword') {
            const oldPassword = changePasswordForm['oldPassword'];
            const newPassword = changePasswordForm['password'];

            if (oldPassword === newPassword) {
                // Set a custom error flag for password field
                changePasswordFormFields['password'].customError = true;
                changePasswordErrors['password'] = "New password cannot be the same as the old password.";
                message.error("New password cannot be the same as the old password.");
            } else {
                changePasswordFormFields['password'].customError = false;
                changePasswordErrors['password'] = null;
            }
        }

        this.setState({ changePasswordForm }, async () => {
            const isChangePassowordDisabled = this.changePasswordDisabled();
            this.setState({
                isChangePassowordDisabled,
            });
            await this.checkValidationMatchString(name)
            this.handleTouch({ target: { name: name } })
            // console.log("changePasswordForm", changePasswordForm)
        });
    }

    checkValidationMatchString = async (name) => {
        const { changePasswordForm } = this.state;
        if (changePasswordForm.password && changePasswordForm.password.length > 0 && changePasswordForm.confirmPw && changePasswordForm.confirmPw.length > 0 && changePasswordForm.password != changePasswordForm.confirmPw) {
            changePasswordFormFields.confirmPw.customError = true;
            if (name == "password") {
                this.handleTouch({ target: { name: 'confirmPw' } })
            }
        }
        else if (changePasswordForm.password && changePasswordForm.password.length > 0 && changePasswordForm.confirmPw && changePasswordForm.confirmPw.length > 0 && changePasswordForm.password == changePasswordForm.confirmPw) {
            changePasswordFormFields.confirmPw.customError = false;
            if (name == "password") {
                this.handleTouch({ target: { name: 'confirmPw' } })
            }
        }
        else {
            changePasswordFormFields.confirmPw.customError = false
        }
    }

    handleOldPassword = async (e) => {
        // const {changePasswordFormFieldsState} = this.props
        if (changePasswordFormFields.oldPassword.type === 'password') {
            changePasswordFormFields.oldPassword.type = "text"
        } else {
            changePasswordFormFields.oldPassword.type = "password"
        }

        return this.setState(changePasswordFormFields)
    }

    handlePassword = async (e) => {
        // const {changePasswordFormFieldsState} = this.props
        if (changePasswordFormFields.password.type === 'password') {
            changePasswordFormFields.password.type = "text"
        } else {
            changePasswordFormFields.password.type = "password"
        }

        return this.setState(changePasswordFormFields)
    }

    handleConfirmPassword = async (e) => {
        if (changePasswordFormFields.confirmPw.type === 'password') {
            changePasswordFormFields.confirmPw.type = "text"
        } else {
            changePasswordFormFields.confirmPw.type = "password"
        }

        return this.setState(changePasswordFormFields)

    }

    passwordValidation = (propsData) => {

        const { password = '' } = propsData
        // console.log("password", password)

        function renderErrorMessage(condition, message) {
            if (!condition) {
                return <p className='error-message' style={{ marginBottom: 0 }}>{message}</p>;
            }
            return null;
        }

        return (
            <div style={{ marginTop: -15 }}>
                {renderErrorMessage(/(?=.*[A-Z])/.test(password), "- Contain at least one uppercase letter (A-Z).")}
                {renderErrorMessage(/(?=(?:.*[a-z]){5,})/.test(password), "- Contain at least five lowercase letters (a-z).")}
                {renderErrorMessage(/.*\d.*\d.*/.test(password), "- Include at least two digits (0-9).")}
                {renderErrorMessage(/^(?=.*@)[a-zA-Z0-9@]+$/.test(password), "- Include at least one special character (@).")}
                {renderErrorMessage(!(password.length < 9), "- Be at least 9 characters long.")}
            </div>
        );
    }

    scrollToCenterHandler = () => {
        if (this.orgChartRef.current) {
            // Check for the method before calling it
            if (typeof this.orgChartRef.current.scrollToCenter === 'function') {
                this.orgChartRef.current.scrollToCenter();
            } else {
                console.warn('scrollToCenter function is not defined');
            }
        }
    }

    toast = (status, msg) => {
        this.setState({ enableToast: true, toastStatus: status, toastMsg: msg });
        return;
    }

    confirmationCallbackModel = (id) => {
        const { method } = this.state;

        this.setState({ enableToast: false }, () => {
            if (method == "contactSupport") {
                this.submitContactForm()
            }
            else if (method == "changePassword") {
                this.handleUpdateProfile("password")
            }
        });
    }

    handleToastStatus = (status) => {
        this.setState({ enableToast: status });
    }

    handleMenuOpen = (event) => {
        this.viewPreferenceApiCall()
        this.setState({ anchorEl: event.currentTarget });
    };

    handleMenuClose = () => {
        this.setState({ anchorEl: null });
    };

    handleItemClick = (item) => {
        console.log(`Clicked: ${item.label}`);
        // You can add specific actions based on the clicked item
        this.handleMenuClose();
    };

    onSort = (order) => {
        const sortedItems = order.map((id) => this.state.items.find((item) => item.id === id));
        this.setState({ items: sortedItems });
    };

    // onReorder = (newOrder) => {
    //     this.setState({ accordionSections: newOrder });
    // };

    onReorder = (newOrder) => {
        // Update the accordion sections with new order and seq values
        const updatedSections = newOrder.map((section, index) => ({
            ...section,
            seq: index + 1, // Increment the sequence by 1 to match the index order
        }));
        console.log("updatedSections", updatedSections)
        this.setState({ accordionSections: updatedSections });
    };


    onToggleExpand = (id) => {
        const updatedSections = this.state.accordionSections.map((section) =>
            section.id === id ? { ...section, expanded: !section.expanded } : section
        );
        this.setState({ accordionSections: updatedSections });
    };

    handleApply = async () => {
        console.log("accordionSections", this.state.accordionSections)
        // debugger;

        const viewPreferences = this.state.accordionSections.map((section) => ({
            ...(section.isFirstTime == false && { id: section.id.substring(8) }), // Include id only if section.id exists
            cardId: section.cardId,
            // defaultPage: section.cardId,
            seq: section.seq,
            cardProperties: `${section.view.toLowerCase()}`,
            isActive: section.visible ? 1 : 0
        }));


        // Create viewPreferencesRequest object
        const viewPreferencesRequest = {
            viewPreferences,
        };

        // Do something with viewPreferencesRequest, like sending it to an API endpoint
        console.log("viewPreferencesRequest", viewPreferencesRequest);

        try {
            const { postHomePreferenceAction } = this.props;
            const { requiredAuth: { tenantId, authToken, userId } } = this.state;

            let payload = { viewPreferencesRequest };

            const params = { addup: "auto" };

            const { responseCode: { status = "", msg } } = await postHomePreferenceAction({ tenantId, authToken, userId, payload, params });

            if (isApiCallSuccess(status)) {
                message.success(msg)
                this.handleMenuClose(); // Close the dropdown menu
            }
            else {
                message.error(msg)
                console.error("Failed to update Preference:", msg);
            }
        } catch (error) {
            console.error("Error updating user Preference:", error);
        }

        // Store the new order and state in local storage
        // localStorage.setItem(ACCORDION_KEY, JSON.stringify(this.state.accordionSections));
    };

    handleResetAll = () => {
        const resetSections = this.state.accordionSections.map((section) => ({
            ...section,
            // expanded: false,
            view: "Collapsed",
            visible: true,
        }));
        this.setState({ accordionSections: resetSections });
    };


    renderAccordionContent(section) {
        const { displayMode, recommendListDataArray, filterDraftCampaign, advertiserSectionListData } = this.state;

        if (!section.visible || section.title === 'Notification') {
            return null; // Skip rendering if not visible or if the title is "notification"
        }

        switch (section.title) {
            case 'My Top Performing Accounts and Campaigns':
                return (
                    <div style={{ position: "relative" }}>
                        <button className={`btn ${displayMode == 'table' ? 'btn-primary' : 'btn-secondary'}`} onClick={this.toggleToTable}
                            style={{
                                borderRadius: '50%', width: '40px', height: '40px', padding: 0,
                                position: "absolute",
                                right: 70,
                                top: 0,
                                zIndex: 99
                            }}>
                            <i className='ti ti-table ti-sm mr-0'></i>
                        </button>
                        <button className={`btn ${displayMode == 'graph' ? 'btn-primary' : 'btn-secondary'}`} onClick={this.toggleToGraph}
                            style={{
                                borderRadius: '50%', width: '40px', height: '40px', padding: 0,
                                position: "absolute",
                                right: 20,
                                top: 0,
                                zIndex: 99
                            }}>
                            <i className='ti ti-chart-bar ti-sm mr-1'></i>
                        </button>

                        {/* My top performing accounts content */}
                        <Tabs defaultActiveKey="1" onChange={(key) => this.handleTabChange(key)}
                            tabBarStyle={{ borderRadius: '5px', fontFamily: "Poppins" }}>
                            <TabPane tab="Last Day" key="lastDay">
                                {this.renderContent()}
                            </TabPane>
                            <TabPane tab="Last 7 Days" key="last7Days">
                                {this.renderContent()}
                            </TabPane>
                            <TabPane tab="Last 15 Days" key="last15Days">
                                {this.renderContent()}
                            </TabPane>
                            <TabPane tab="Last Month" key="lastMonth">
                                {this.renderContent()}
                            </TabPane>
                        </Tabs>


                    </div>
                );
            case 'Account with Most Recommendations':
                return (
                    // <div className="row">
                    //     {recommendListDataArray && recommendListDataArray.length > 0
                    //         ? recommendListDataArray.map((item, key) => (
                    //             <div className="col-md-4" key={key}>
                    //                 <div className="reco-card">
                    //                     <div className="reco-card-body p-3">
                    //                         <h5 className="reco-card-title">{item.tenantName}</h5>
                    //                         <p className="card-text">
                    //                             Total Recommendations:<strong>{item.totalRecommendations}</strong>
                    //                         </p>
                    //                         <hr className="mx-n3" style={{ borderTop: 'dotted 1px' }} />
                    //                         <div className="row">
                    //                             {item.businessAttr.map((attrObj, key) => (
                    //                                 <div className="col-md-3 pr-0" key={key}>
                    //                                     {Object.entries(attrObj).map(([attrKey, attrValue], index) => (
                    //                                         <React.Fragment key={index}>
                    //                                             <div style={{ fontSize: 14, fontWeight: 600, color: '#040B1B' }}>
                    //                                                 {attrValue}
                    //                                             </div>
                    //                                             <div style={{ fontSize: 10 }}>{attrKey}</div>
                    //                                         </React.Fragment>
                    //                                     ))}
                    //                                 </div>
                    //                             ))}
                    //                         </div>
                    //                     </div>
                    //                 </div>
                    //             </div>
                    //         ))
                    //         : <div style={{ fontFamily: 'Poppins', padding: 10 }}>No Data Available</div>}
                    // </div>

                    <div className="row overflow-auto flex-nowrap">
                        {recommendListDataArray && recommendListDataArray.length > 0
                            ? recommendListDataArray.map((item, key) => (
                                <div className="col-md-4" key={key}>
                                    <div className="reco-card">
                                        <div className="reco-card-body p-3">
                                            <h5 className="reco-card-title">{item.tenantName}</h5>
                                            <p className="card-text">
                                                Total Recommendations:<strong>{item.totalReco}</strong>
                                            </p>
                                            <hr className="mx-n3" style={{ borderTop: 'dotted 1px' }} />
                                            <div className="row">
                                                {item.details.map((detail, index) => (
                                                    <div className="col-md-6 pr-0" key={index}>
                                                        <div style={{ fontSize: 14, fontWeight: 600, color: '#040B1B' }}>
                                                            {detail.recoTypeName}
                                                        </div>
                                                        <div style={{ fontSize: 10 }}>Count: {detail.recoCount}</div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                            : <div style={{ fontFamily: 'Poppins', padding: 10 }}>No Data Available</div>}
                    </div>
                );
            case 'Draft Campaigns':
                return (
                    <div className="campaign-adj">
                        <div className="campaign-list-adj table-responsive">
                            <Table
                                options={draftCampaignOptions}
                                data={filterDraftCampaign || []}
                            />
                        </div>
                    </div>
                );
            case 'Advertiser Section':
                return (
                    <div className="campaign-adj">
                        <div className="campaign-list-adj table-responsive">
                            <Table
                                options={advertiserOptions}
                                data={advertiserSectionListData || []}
                            />
                        </div>
                    </div>
                );
            default:
                return null;
        }
    }

    onToggleVisibility = (id) => {
        const updatedSections = this.state.accordionSections.map((section) =>
            section.id === id ? { ...section, visible: !section.visible } : section
        );
        this.setState({ accordionSections: updatedSections });
    };

    onChangeView = (id, view) => {
        const updatedSections = this.state.accordionSections.map((section) =>
            section.id === id ? { ...section, view } : section
        );
        this.setState({ accordionSections: updatedSections });
    };

    handleAccordionChange = (accordionId) => {
        this.setState((prevState) => ({
            expandedAccordion: prevState.expandedAccordion === accordionId ? null : accordionId
        }));
    };

    render() {
        // const preSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
        // const { responseList, username } = preSignInData;
        const {
            isSignInProceedDisabled, collapse, isAgency,
            tenantId, checkFlag, showSpinner, showSignInSelect,
            notificationListData, recentActivityData, recommendListDataArray,
            draftCampaignListData, draftMergeTenantArray, filterDraftCampaign,
            advertiserSectionListData, accPerformanceListData, displayMode,
            draftTenantDropDown, draftTenantDropDownWidth, selectedDraftTenant,
            openHelpModal, form, errors, touched, submited, openAccountAccess, openUserProfile,
            openChangePassword, changePasswordForm, changePasswordTouched, changePasswordErrors, changePasswordSubmited,
            editEmail, editName, userProfileDetails, base64Image, displayAccountAccessMode, accountAccessData,
            enableToast, toastStatus, toastMsg, confirmationMsg,
            anchorEl, items, accordionSections, expandedAccordion
        } = this.state;
        const open = Boolean(anchorEl);

        const { classes, preSignInResponseList, history, history: { location: { pathname = '' } } } = this.props;

        // const filteredList = preSignInResponseList.filter(item => isAgency ? item.tenantType === "DSP/Ad network" || item.tenantType === "Advertiser & DSP/Ad network" : !(item.tenantType === "DSP/Ad network" || item.tenantType === "Advertiser & DSP/Ad network"))
        const filteredList = preSignInResponseList.filter(item => {
            if (item.tenantType === "Platform Manager") {

                return true;
            }
            return isAgency
                ? item.tenantType === "DSP/Ad network" || item.tenantType === "Advertiser & DSP/Ad network" || item.tenantType === "Demo Agency"
                : !(item.tenantType === "DSP/Ad network" || item.tenantType === "Advertiser & DSP/Ad network" || item.tenantType === "Demo Agency");
        });

        const isNameInvalid = errors.name && Object.keys(errors.name).length > 0
        const isEmailInvalid = errors.email && Object.keys(errors.email).length > 0

        // console.log(preSignInResponseList)
        // console.log("draftTenantDropDown", draftTenantDropDown)
        // console.log("recentActivityData", recentActivityData)
        // console.log(showSpinner, 'showSpinner');
        const PreSignInData = JSON.parse(localStorage.getItem('PreSignInData'));
        // console.log("PreSignInState", PreSignInState)

        return (
            <React.Fragment>
                {showSpinner && <Spinner />}


                {
                    enableToast && <ToastModal
                        enableToast={enableToast}
                        status={toastStatus}
                        msg={toastMsg}
                        // path={routes.containers.mediaPlan}
                        idProps={this.props}
                        handleConfirmation={this.confirmationCallbackModel}
                        handleToastStatus={this.handleToastStatus}
                        confirmationMsg={confirmationMsg}
                        poc={true}
                    />
                }


                {<Modal open={openHelpModal}
                    onClose={() => { this.setState({ openHelpModal: !openHelpModal }) }}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title align-self-center">Contact us</h5>
                            <button type="button" onClick={() => { this.setState({ openHelpModal: !openHelpModal }) }} className="close" data-dismiss="modal" aria-label="Close">
                                <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">×</span></div>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className='row form__style'>
                                <div className='col-md-12'>
                                    <Input
                                        onChange={this.handleChange}
                                        onBlur={this.handleTouch}
                                        value={form[formFields.name.key]}
                                        setting={formFields[formFields.name.key]}
                                        error={errors[formFields.name.key]}
                                        submited={submited}
                                        touched={touched[formFields.name.key]}
                                    />
                                </div>
                                <div className='col-md-6'>
                                    <Input
                                        onChange={this.handleChange}
                                        onBlur={this.handleTouch}
                                        value={form[formFields.email.key]}
                                        setting={formFields[formFields.email.key]}
                                        error={errors[formFields.email.key]}
                                        submited={submited}
                                        touched={touched[formFields.email.key]}
                                    />
                                </div>
                                <div className='col-md-6'>
                                    <Input
                                        onChange={this.handleChange}
                                        onBlur={this.handleTouch}
                                        value={form[formFields.contact.key]}
                                        setting={formFields[formFields.contact.key]}
                                        error={errors[formFields.contact.key]}
                                        submited={submited}
                                        touched={touched[formFields.contact.key]}
                                    />
                                </div>
                                <div className='col-md-12'>
                                    <Textarea
                                        onChange={this.handleChange}
                                        onBlur={this.handleTouch}
                                        value={form[formFields.message.key]}
                                        setting={formFields[formFields.message.key]}
                                        error={errors[formFields.message.key]}
                                        submited={submited}
                                        touched={touched[formFields.message.key]}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={() => { this.setState({ openHelpModal: !openHelpModal }) }} className="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="button" onClick={this.handleSubmit} className="btn btn-primary" data-dismiss="modal">Send</button>
                        </div>
                    </div>
                </Modal>}

                {<Modal open={openUserProfile}
                    onClose={() => { this.setState({ openHelpModal: !openHelpModal }) }}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title align-self-center">User Profile</h5>
                            <button type="button" onClick={() => { this.setState({ openUserProfile: !openUserProfile }) }} className="close" data-dismiss="modal" aria-label="Close">
                                <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">×</span></div>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div class="container">
                                <div class="row align-items-center">
                                    {/* <!-- User Image Section --> */}
                                    <div class="col-md-3 justify-content-center d-flex">
                                        <div class="user-image text-center align-items-center d-flex justify-content-center border border-dotted rounded-3" style={{ position: "relative", width: "150px", height: "150px" }}>
                                            {base64Image ? <img src={base64Image} alt="User" style={{ maxWidth: '100%', width: "100%", height: "100%", objectFit: "cover", boxShadow: "0px 0px 10px 5px #9b9b9b33" }} />
                                                : <>
                                                    <>Choose an image to upload</>
                                                    {/* <i className='ti ti-photo ti-xl' /> */}
                                                </>
                                            }
                                            {/* Hidden File Input */}
                                            <input
                                                type="file"
                                                accept="image/*"
                                                id="fileInput"
                                                className="form-control-file"
                                                style={{ display: 'none' }}
                                                onChange={this.handleImageChange}
                                            />
                                            {/* Button to Trigger File Input */}
                                            <button
                                                className="btn btn-primary rounded-circle"
                                                style={{ position: 'absolute', bottom: '-5px', right: '-7px', height: 33, width: 30, textAlign: "center", background: "#fff" }}
                                                onClick={() => this.triggerFileInput()}
                                                title="Change Image"
                                            >
                                                <i className="ti ti-pencil mr-0" style={{ fontSize: '18px' }} />
                                            </button>
                                        </div>
                                    </div>

                                    {/* User Info Section */}
                                    <div className="col-md-9 d-flex flex-column border rounded-3 pt-3">
                                        {/* User Name */}
                                        <div className="mb-3 d-flex justify-content-between align-items-center">
                                            <div>
                                                {editName ? (
                                                    // <Input
                                                    //     type="text"
                                                    //     value={userProfileDetails.name}
                                                    //     onChange={(e) => this.handleInputChange(e, "name")}
                                                    // />
                                                    <div className='row form__style'>
                                                        <div className='col-md-12 mb-n3 pt-1'>
                                                            <Input
                                                                onChange={(e) => this.handleInputChange(e, "name")}
                                                                onBlur={this.handleDetailsTouch}
                                                                value={userProfileDetails[userProfileFormFields.name.key]}
                                                                setting={userProfileFormFields[userProfileFormFields.name.key]}
                                                                error={errors[userProfileFormFields.name.key]}
                                                                submited={submited}
                                                                touched={touched[userProfileFormFields.name.key]}
                                                            />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <strong className="h5"><span style={{ fontWeight: "600" }}>Name :</span> &nbsp;{userProfileDetails && userProfileDetails.name}</strong>
                                                )}
                                            </div>
                                            <div>
                                                <button
                                                    className="btn btn-primary btn-sm"
                                                    disabled={isNameInvalid}
                                                    onClick={() => {
                                                        if (editName) {
                                                            this.handleUpdateProfile("editName");
                                                        } else {
                                                            this.handleEditToggle("editName");
                                                        }
                                                    }}
                                                >
                                                    <i style={{ fontSize: 18 }} className={editName ? 'ti ti-refresh' : 'ti ti-pencil'} />
                                                    {editName ? "Update" : "Edit"}
                                                </button>

                                                {editName &&
                                                    <button
                                                        className="btn btn-outline-primary btn-sm ml-3"
                                                        onClick={() => {
                                                            this.handleEditToggle("editName");
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>
                                                }
                                            </div>
                                        </div>

                                        {/* User Email */}
                                        {!this.state.otpVisible && (
                                            <div className="mb-3 d-flex justify-content-between align-items-center">
                                                <div>

                                                    {editEmail ? (
                                                        // <Input
                                                        //     type="text"
                                                        //     value={userProfileDetails.email}
                                                        //     onChange={(e) => this.handleInputChange(e, "email")}
                                                        // />
                                                        <div className='row form__style'>
                                                            <div className='col-md-12 mb-n3 pt-1'>
                                                                <Input
                                                                    onChange={(e) => this.handleInputChange(e, "email")}
                                                                    onBlur={this.handleDetailsTouch}
                                                                    value={userProfileDetails[userProfileFormFields.email.key]}
                                                                    setting={userProfileFormFields[userProfileFormFields.email.key]}
                                                                    error={errors[userProfileFormFields.email.key]}
                                                                    submited={submited}
                                                                    touched={touched[userProfileFormFields.email.key]}
                                                                />
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <strong className="h5"><span style={{ fontWeight: "600" }}>Email :</span> &nbsp; {userProfileDetails && userProfileDetails.email}</strong>
                                                    )}
                                                </div>
                                                <div>
                                                    <button
                                                        className="btn btn-primary btn-sm"
                                                        disabled={isEmailInvalid}
                                                        onClick={() => {
                                                            if (editEmail) {
                                                                this.handleUpdateProfile("editEmail");
                                                            } else {
                                                                this.handleEditToggle("editEmail");
                                                            }
                                                        }}
                                                    >
                                                        <i style={{ fontSize: 18 }} className={editEmail ? 'ti ti-refresh' : 'ti ti-pencil'} />
                                                        {editEmail ? "Update" : "Edit"}
                                                    </button>

                                                    {editEmail &&
                                                        <button
                                                            className="btn btn-outline-primary btn-sm ml-3"
                                                            onClick={() => {
                                                                this.handleEditToggle("editEmail");
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                        )}

                                        {this.state.otpVisible && (
                                            <div className='d-flex justify-content-between align-items-center'>
                                                {/* <input
                                                        type="text"
                                                        value={this.state.otp}
                                                        onChange={(e) => this.setState({ otp: e.target.value })}
                                                    /> */}
                                                <div className='row form__style'>
                                                    <div className='col-md-12 mb-n3 pt-1'>
                                                        {/* <label>Enter OTP:</label> */}
                                                        <Input
                                                            onChange={(e) => this.handleInputChange(e, "otp")}
                                                            onBlur={this.handleDetailsTouch}
                                                            value={userProfileDetails[userProfileFormFields.otp.key]}
                                                            setting={userProfileFormFields[userProfileFormFields.otp.key]}
                                                            error={errors[userProfileFormFields.otp.key]}
                                                            submited={submited}
                                                            touched={touched[userProfileFormFields.otp.key]}
                                                        />
                                                        <span className='pt-1'>Time Remaining: {this.formatTime(this.state.remainingTime)}</span> {/* Display the timer in MM:SS */}
                                                    </div>

                                                </div>
                                                <div>
                                                    <button
                                                        className="btn btn-primary btn-sm"
                                                        disabled={userProfileDetails ?
                                                            userProfileDetails[userProfileFormFields.otp.key] ?
                                                                userProfileDetails[userProfileFormFields.otp.key].toString().length == 6 ? false : true : true : true}
                                                        onClick={() => {
                                                            this.handleUpdateProfile("otp");
                                                        }}
                                                    >
                                                        Validate OTP
                                                    </button>
                                                    <button
                                                        className="btn btn-outline-primary btn-sm ml-3"
                                                        onClick={() => {
                                                            this.setState({ otpVisible: false });
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={() => { this.setState({ openUserProfile: !openUserProfile }) }} className="btn btn-secondary" data-dismiss="modal">Close</button>
                            {/* <button type="button" className="btn btn-primary" data-dismiss="modal">Send</button> */}
                        </div>
                    </div>
                </Modal>}

                {<Modal open={openChangePassword}
                    onClose={() => { this.setState({ openChangePassword: !openChangePassword }) }}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title align-self-center">Change Password</h5>
                            <button type="button" onClick={() => { this.setState({ openChangePassword: !openChangePassword }) }} className="close" data-dismiss="modal" aria-label="Close">
                                <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">×</span></div>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form id="formAuthentication" class="mb-3" onSubmit={this.handleResetSubmit}>
                                <div className='mb-3'>
                                    <div style={{ position: 'relative' }}>
                                        <Input
                                            onChange={this.handleChangePassword}
                                            onBlur={this.handlePasswordCTouch}
                                            value={changePasswordForm[changePasswordFormFields.oldPassword.key]}
                                            setting={changePasswordFormFields[changePasswordFormFields.oldPassword.key]}
                                            error={changePasswordErrors[changePasswordFormFields.oldPassword.key]}
                                            submited={changePasswordSubmited}
                                            touched={changePasswordTouched[changePasswordFormFields.oldPassword.key]}
                                        />
                                        <i style={{ position: 'absolute', top: 42, right: 15 }} onClick={this.handleOldPassword} class={`ti ${changePasswordFormFields.oldPassword.type == "password" ? "ti-eye-off" : "ti-eye"} cursor-pointer`}>
                                        </i>
                                    </div>
                                    {
                                        errors[changePasswordFormFields.oldPassword.key] &&
                                        <this.passwordValidation password={changePasswordForm[changePasswordFormFields.oldPassword.key]} />
                                    }
                                </div>
                                <div class="mb-3 ">
                                    <div style={{ position: 'relative' }}>
                                        <Input
                                            onChange={this.handleChangePassword}
                                            onBlur={this.handleTouch}
                                            value={changePasswordForm[changePasswordFormFields.password.key]}
                                            setting={changePasswordFormFields[changePasswordFormFields.password.key]}
                                            error={errors[changePasswordFormFields.password.key]}
                                            submited={submited}
                                            touched={touched[changePasswordFormFields.password.key]}
                                        />
                                        <i style={{ position: 'absolute', top: 42, right: 15 }} onClick={this.handlePassword} class={`ti ${changePasswordFormFields.password.type == "password" ? "ti-eye-off" : "ti-eye"} cursor-pointer`}>
                                        </i>
                                    </div>
                                    {
                                        errors[changePasswordFormFields.password.key] &&
                                        <this.passwordValidation password={changePasswordForm[changePasswordFormFields.password.key]} />
                                    }
                                </div>
                                <div class="mb-3">
                                    <div style={{ position: 'relative' }}>
                                        <Input
                                            onChange={this.handleChangePassword}
                                            onBlur={this.handleTouch}
                                            value={changePasswordForm[changePasswordFormFields.confirmPw.key]}
                                            setting={changePasswordFormFields[changePasswordFormFields.confirmPw.key]}
                                            error={errors[changePasswordFormFields.confirmPw.key]}
                                            submited={submited}
                                            touched={touched[changePasswordFormFields.confirmPw.key]}
                                        />
                                        <i style={{ position: 'absolute', top: 42, right: 15 }} onClick={this.handleConfirmPassword} class={`ti ${changePasswordFormFields.confirmPw.type == "password" ? "ti-eye-off" : "ti-eye"} cursor-pointer`}>
                                        </i>
                                    </div>
                                    {
                                        errors[changePasswordFormFields.confirmPw.key] &&
                                        <this.passwordValidation password={changePasswordForm[changePasswordFormFields.confirmPw.key]} />
                                    }
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" disabled={this.changePasswordDisabled()} onClick={this.handleResetSubmit} data-dismiss="modal">Reset Password</button>
                            <button type="button" onClick={() => { this.setState({ openChangePassword: !openChangePassword }) }} className="btn btn-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </Modal>}

                {<Modal open={openAccountAccess} size={this.state.accountAccessData.length > 25 ? "fullscreen" : "large"}
                    onClose={() => { this.setState({ openAccountAccess: !openAccountAccess }) }}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title align-self-center">Account Access</h5>
                            <button type="button" onClick={() => { this.setState({ openAccountAccess: !openAccountAccess }) }} className="close" data-dismiss="modal" aria-label="Close">
                                <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">×</span></div>
                            </button>
                        </div>
                        <div className="modal-body">
                            {accountAccessData && accountAccessData.length > 0 ?
                                <>
                                    <div style={{ position: "relative" }}>
                                        <button className={`btn ${displayAccountAccessMode == 'table' ? 'btn-primary' : 'btn-secondary'}`} onClick={this.toggleAccountAccessTable}
                                            style={{
                                                borderRadius: '50%', width: '32px', height: '32px', padding: 0,
                                                position: "absolute",
                                                right: 70,
                                                top: 4,
                                                zIndex: 99
                                            }}>
                                            <i className='ti ti-table ti-sm mr-0'></i>
                                        </button>
                                        <button className={`btn ${displayAccountAccessMode == 'graph' ? 'btn-primary' : 'btn-secondary'}`} onClick={this.toggleAccountAccessGraph}
                                            style={{
                                                borderRadius: '50%', width: '32px', height: '32px', padding: 0,
                                                position: "absolute",
                                                right: 20,
                                                top: 4,
                                                zIndex: 99
                                            }}>
                                            <i className='ti ti-hierarchy ti-sm mr-0'></i>
                                        </button>
                                    </div>
                                    <>
                                        {this.renderAccountAccess()}
                                    </>
                                </>
                                :

                                <div className='text-center'>
                                    <h5>No Data Available</h5>
                                </div>
                            }
                        </div>
                        {/* <div className="modal-footer">
                            <button type="button" onClick={() => { this.setState({ openAccountAccess: !openAccountAccess }) }} className="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="button" onClick={this.handleSubmit} className="btn btn-primary" data-dismiss="modal">Send</button>
                        </div> */}
                    </div>
                </Modal>}

                {showSignInSelect &&
                    <AuthenticationBody>
                        <div className={`${collapse ? 'homeLayout-adj collapseWrapper p-0' : ''}`}>
                            {/* <HomeHeader toggleSidebar={this.toggleSidebar} /> */}
                            {/* <SideNav toggleSidebar={this.toggleSidebar} /> */}
                            {!pathname.includes('atd-home') &&
                                <div class=" col-12 mt-5">
                                    <nav
                                        class="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme mt-0 pl-1"
                                        // id="layout-navbar"
                                        style={{
                                            position: 'fixed',
                                            top: 0,
                                            right: 0,
                                            left: 85,
                                            flexWrap: 'nowrap',
                                            maxWidth: "96%",
                                            width: "96%"
                                        }}
                                    >
                                        <div class="layout-menu-toggle navbar-nav align-items-xl-center me-3">
                                            <a onClick={(e) => this.collapseToggle(e)} class="nav-item nav-link px-0 me-xl-4 d-xl-none" href="javascript:void(0)">
                                                <i class="ti ti-menu-2 ti-sm"></i>
                                            </a>
                                        </div>

                                        <div class="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
                                            {/* <h6 style={{ color: "#394256", fontSize: 20 }} className='mb-0'>Welcome <strong>{PreSignInData && PreSignInData.username}</strong>👋</h6> */}
                                            <h6 style={{ color: "#394256", fontSize: 20 }} className='mb-0'>Welcome <strong>{this.state.userProfileDetails && this.state.userProfileDetails.name}</strong>👋</h6>

                                            <ul class="navbar-nav flex-row align-items-center ms-auto">
                                                <li className="nav-item tenantDropddown me-4 d-flex align-items-center">
                                                    {preSignInResponseList && preSignInResponseList.length > 0 && preSignInResponseList[0].tenantType && preSignInResponseList[0].tenantType == "Platform Manager" &&
                                                        <div style={{ margin: 10 }}>Account:</div>
                                                    }

                                                    <div>
                                                        <form id="formAuthentication" class="mt-3" onSubmit={(e) => { this.handleSignInProceed(e) }}>
                                                            <div class="mb-3">
                                                                {/* // TODO:-----Check for in and out and in  */}
                                                                <select id="selectpickerBasic"
                                                                    style={{
                                                                        height: 36,
                                                                        border: '1px solid grey',
                                                                        color: 'grey',
                                                                        borderRadius: '3px',
                                                                        backgroundColor: 'white'
                                                                    }}
                                                                    onChange={this.handleFormFieldChange} class="form-select bg-beki w-100 pr-0" data-style="btn-default">
                                                                    <option selected disabled value="">Select</option>
                                                                    {filteredList && filteredList.map((responseList, index) => {
                                                                        return (

                                                                            <>
                                                                                {/* <option key={index} value={(responseList.accountType === 0) ? `${responseList.parentTenantName}` : `${responseList.parentTenantName}(${responseList.tenantName})`}> */}
                                                                                <option key={index} value={responseList.tenantId}>
                                                                                    {(responseList.accountType === 0) ? `${responseList.parentTenantName}` : `${responseList.tenantName} (${responseList.parentTenantName})`}
                                                                                </option>

                                                                            </>
                                                                        )
                                                                    })
                                                                    }
                                                                </select>
                                                            </div>
                                                        </form>
                                                    </div>
                                                    {preSignInResponseList && preSignInResponseList.length > 0 && preSignInResponseList[0].tenantType != "Platform Manager" &&
                                                        <div className='d-flex align-items-center tenant-switch border p-2' style={{ borderRadius: "0 20px 20px 0" }}>
                                                            <Switch
                                                                checked={isAgency}
                                                                onChange={this.handleToggle}
                                                                checkedChildren={<span style={{ color: 'white', fontWeight: 600 }}>Agency</span>} // Change color for on state
                                                                unCheckedChildren={<span style={{ color: 'white', fontWeight: 600 }}>Advertiser</span>} // Change color for off state
                                                                className="agency-switch small-switch" // Apply custom class for styling
                                                            />

                                                        </div>
                                                    }
                                                </li>

                                                <li class="nav-item navbar-dropdown dropdown-user dropdown">
                                                    <a class="nav-link dropdown-toggle hide-arrow" href="javascript:void(0);" data-bs-toggle="dropdown">
                                                        <div class="avatar avatar-online">
                                                            {
                                                                base64Image ?
                                                                    <img style={{ width: '100%', height: '100%' }} className="img-fluid rounded-circle" src={base64Image} alt="profile" />
                                                                    :
                                                                    <i class="ti ti-user-circle ti-lg" ></i>
                                                            }
                                                        </div>
                                                    </a>
                                                    <ul class="dropdown-menu dropdown-menu-end">
                                                        {/* <li>
                                                            <a class="dropdown-item avatar-adj" href="#">
                                                                <div class="avatar avatar-online avatar-dropdown">
                                                                    <i class="ti ti-user-circle me-2 ti-sm" ></i>
                                                                </div>
                                                                <span class="align-middle">{PreSignInData && PreSignInData.username}</span>
                                                            </a>
                                                        </li> */}
                                                        <li>
                                                            <a class="dropdown-item avatar-adj" style={{ cursor: 'pointer' }} onClick={() => this.setState({ openUserProfile: true }, () => {
                                                                // this.userProfileDetails()
                                                            })}>
                                                                <div class="avatar avatar-online avatar-dropdown">
                                                                    <i class="ti ti-user-circle me-2 ti-sm" ></i>
                                                                </div>
                                                                {/* <span class="align-middle">{username}</span> */}
                                                                <span class="align-middle">User Profile</span>

                                                            </a>
                                                        </li>
                                                        <li>
                                                            <div class="dropdown-divider"></div>
                                                        </li>
                                                        <li>
                                                            <a class="dropdown-item avatar-adj" href="#" onClick={() => this.handleAccountAccess()}>
                                                                <i class="ti ti-file-settings ti-sm" ></i>
                                                                <span class="align-middle">Accounts & Access</span>

                                                            </a>
                                                        </li>
                                                        <li>
                                                            <div class="dropdown-divider"></div>
                                                        </li>
                                                        <li>
                                                            <a class="dropdown-item" href="#" onClick={() => { this.setForm() }} >
                                                                <i class="ti ti-help me-2 ti-sm"></i>
                                                                <span class="align-middle">Help</span>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <div class="dropdown-divider"></div>
                                                        </li>
                                                        <li>
                                                            <a class="dropdown-item avatar-adj" style={{ cursor: 'pointer' }} onClick={() => this.changePasswordAction()}>
                                                                <i className="ti ti-square-asterisk me-2 ti-sm" ></i>
                                                                <span class="align-middle">Change Password</span>

                                                            </a>
                                                        </li>
                                                        <li>
                                                            <div class="dropdown-divider"></div>
                                                        </li>
                                                        <li>
                                                            <a class="dropdown-item" href="#" onClick={() => { this.setForm() }} >
                                                                <i class="ti ti-help me-2 ti-sm"></i>
                                                                <span class="align-middle">Help</span>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <div class="dropdown-divider"></div>
                                                        </li>
                                                        <li>
                                                            <a class="dropdown-item" href="#" onClick={this.handleLogout} >
                                                                <i class="ti ti-logout me-2 ti-sm"></i>
                                                                <span class="align-middle">Log Out</span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                    </nav>
                                </div>
                            }
                            {!pathname.includes('atd-home') &&
                                <aside id="layout-menu" class="layout-menu menu-vertical menu bg-menu-theme position-fixed shadow-none" data-bg-class="bg-menu-theme" style={{ touchAction: "none", userSelect: "none", minHeight: "100vh", marginTop: -50, opacity: 0.7, pointerEvents: "none" }}>
                                    <div class="app-brand demo">
                                        <a href="javascript:void(0);" class="app-brand-link">
                                            <img src={logo} style={{ maxWidth: 150 }} width="60%" />
                                        </a><a href="javascript:void(0);" class="layout-menu-toggle menu-link text-large ms-auto text-decoration-none"><i class="ti menu-toggle-icon d-none d-xl-block ti-sm align-middle"></i><i class="ti ti-x d-block d-xl-none ti-sm align-middle"></i></a><a href="javascript:void(0);" class="player text-large ms-auto text-decoration-none"><i class="ti ti-player-record ti-sm" style={{ color: "rgb(111, 107, 125)" }}></i></a></div>
                                    <div class="menu-inner-shadow" style={{ display: "none" }}></div>
                                    <ul class="menu-inner py-1 ps ps--active-y">
                                        <div class="menu-item">
                                            <a class="menu-link text-decoration-none" href="javascript:void(0);">
                                                <i class="ti ti-chart-bar ti-md"></i>
                                                <div data-i18n="Dashboard">Dashboard</div>
                                            </a>
                                        </div>
                                        <div class="menu-item">
                                            <a class="menu-link text-decoration-none" href="javascript:void(0);">
                                                <i class="menu-icon tf-icons ti ti-user-circle"></i>
                                                <div data-i18n="Admin">Admin</div>
                                            </a>
                                        </div>
                                        <div class="menu-item">
                                            <a class="menu-link text-decoration-none" href="javascript:void(0);">
                                                <i class="menu-icon tf-icons ti ti-speakerphone"></i>
                                                <div data-i18n="Campaign">Campaign</div>
                                            </a>
                                        </div>
                                        <div class="menu-item">
                                            <a class="menu-link text-decoration-none" href="javascript:void(0);">
                                                <i class="menu-icon tf-icons ti ti-photo"></i>
                                                <div data-i18n="Campaign">Creative</div>
                                            </a>
                                        </div>
                                        <div class="menu-item">
                                            <a class="menu-link text-decoration-none" href="javascript:void(0);">
                                                <i class="menu-icon mdi mdi-database"></i>
                                                <div data-i18n="Margin">Data Config</div>
                                            </a>
                                        </div>
                                        <div class="menu-item">
                                            <a class="menu-link text-decoration-none" href="javascript:void(0);">
                                                <i class="ti ti-coin ti-md"></i>
                                                <div data-i18n="Margin">Billing</div>
                                            </a>
                                        </div>
                                        <div class="menu-item">
                                            <a class="menu-link text-decoration-none" href="javascript:void(0);">
                                                <i class="ti ti-adjustments-alt"></i>
                                                <div data-i18n="Margin"></div>
                                            </a>
                                        </div>
                                    </ul>
                                </aside>
                            }
                            <div className='row mx-2'>
                                <div className={`${pathname.includes('atd-home') ? 'atd-home-adj' : 'home-adj'} homeScreen-adj`}>
                                    <div className='row py-3 pt-5 px-0 justify-content-between d-flex'>
                                        <div
                                            className='col-5'
                                            style={{ fontSize: 20, fontFamily: 'Poppins', color: '#394256', fontWeight: 500 }}
                                        >
                                            Account Overview
                                        </div>
                                        <div className='col-5 text-right'>
                                            <ErrorBoundary>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
                                                    <MUIButton
                                                        variant="outlined"
                                                        color="primary"
                                                        startIcon={<SettingsOutlinedIcon />}
                                                        onClick={this.handleMenuOpen}
                                                        className='text-capitalize bg-white'
                                                    >
                                                        Settings
                                                    </MUIButton>
                                                    <Popover
                                                        open={open}
                                                        anchorEl={anchorEl}
                                                        onClose={this.handleMenuClose}
                                                        anchorOrigin={{
                                                            vertical: 'bottom',
                                                            horizontal: 'right',
                                                        }}
                                                        transformOrigin={{
                                                            vertical: 'top',
                                                            horizontal: 'right',
                                                        }}
                                                        PaperProps={{
                                                            style: {
                                                                width: '600px', // Fixed width
                                                                maxWidth: '600px', // Fixed width
                                                                overflow: 'auto'
                                                            }
                                                        }}
                                                    // classes={{ paper: classes.popover }}

                                                    >
                                                        {/* Content inside Popover */}
                                                        {/* <div> */}

                                                        {/* First Accordion for DraggableDropdown */}
                                                        <Accordion expanded={expandedAccordion === 'draggable'} onChange={() => this.handleAccordionChange('draggable')}
                                                            className={classes.customAccordion}
                                                        >
                                                            <AccordionSummary
                                                                expandIcon={<ExpandMoreIcon className={classes.customExpandIcon} />}
                                                                aria-controls="panel1a-content"
                                                                id="panel1a-header"
                                                                className={classes.customAccordionSummary}
                                                                classes={{ content: classes.customAccordionSummaryContent }}
                                                            >
                                                                {/* Add summary content */}
                                                                Home Page Settings
                                                            </AccordionSummary>
                                                            <AccordionDetails
                                                                className={
                                                                    expandedAccordion === 'draggable'
                                                                        ? classes.expandedAccordionDetails
                                                                        : classes.customAccordionDetails
                                                                }
                                                            >
                                                                <DraggableDropdown
                                                                    anchorEl={anchorEl}
                                                                    // handleMenuOpen={this.handleMenuOpen}
                                                                    handleMenuClose={this.handleMenuClose}
                                                                    accordionSections={accordionSections}
                                                                    onReorder={this.onReorder}
                                                                    onToggleExpand={this.onToggleExpand}
                                                                    onResetAll={this.handleResetAll}
                                                                    onApply={this.handleApply}
                                                                    onToggleVisibility={this.onToggleVisibility}
                                                                    onChangeView={this.onChangeView}
                                                                />
                                                            </AccordionDetails>
                                                        </Accordion>

                                                        {/* Second Accordion */}
                                                        <Accordion expanded={expandedAccordion === 'table'} onChange={() => this.handleAccordionChange('table')}
                                                            className={classes.customAccordion}
                                                        >
                                                            <AccordionSummary
                                                                expandIcon={<ExpandMoreIcon className={classes.customExpandIcon} />}
                                                                aria-controls="panel2a-content"
                                                                id="panel2a-header"
                                                                className={classes.customAccordionSummary}
                                                                classes={{ content: classes.customAccordionSummaryContent }}
                                                            >
                                                                Set Account Default Page
                                                            </AccordionSummary>
                                                            <AccordionDetails
                                                                className={
                                                                    expandedAccordion === 'table'
                                                                        ? classes.expandedAccordionDetails
                                                                        : classes.customAccordionDetails
                                                                }
                                                            >
                                                                <SetAccountsDefaultPage />
                                                            </AccordionDetails>
                                                        </Accordion>
                                                    </Popover>
                                                </div>

                                            </ErrorBoundary>
                                        </div>
                                    </div>


                                    <div className='col-12 px-0'>
                                        {
                                            notificationListData && notificationListData.length > 0 && notificationListData.filter(item => item.action == 1).length > 0 &&
                                            <>
                                                {accordionSections
                                                    .filter(section => section.title == 'Notification')
                                                    .map((section, index) => (
                                                        <div className={`alert-acc-adj accordion mt-3 mb-4 accordion-bordered border border-danger rounded ${section.visible ? '' : ' border-0'}`} id="accordionStyle1">
                                                            <div
                                                                key={section.id}
                                                                className={`card accordion-item mb-0 ${section.view == 'Expanded' ? 'active' : ''}${section.visible ? '' : ' d-none'}`}
                                                            >
                                                                <h2 className="accordion-header">
                                                                    <button
                                                                        type="button"
                                                                        className={`accordion-button mb-0 ${section.view == 'Expanded' ? '' : 'collapsed'}`}
                                                                        data-bs-toggle="collapse"
                                                                        data-bs-target={`#accordion-999`}
                                                                        aria-expanded={section.view == 'Expanded'}
                                                                        aria-controls={`accordion-999`}
                                                                        style={{ fontSize: 13 }}>
                                                                        <i className='ti ti-bell mr-1'></i>You have {notificationListData.filter(item => item.action == 1).length}{" "}{notificationListData.filter(item => item.action == 1).length > 1 ? "Alerts" : "Alert"}.
                                                                    </button>
                                                                </h2>

                                                                <div
                                                                    id={`accordion-999`}
                                                                    className={`accordion-collapse collapse ${section.view == 'Expanded' ? 'show' : ''}`}
                                                                    aria-labelledby={`accordion-999`}
                                                                    data-bs-parent="#accordionStyle1"
                                                                >
                                                                    <div className="accordion-body p-0">
                                                                        {notificationListData.filter(item => item.action == 1).map((item, key) =>
                                                                            <div class="alert alert-danger border-0 d-flex justify-content-between mb-0" role="alert" key={key}>
                                                                                <div> <i className='ti ti-alert-triangle mr-1 mt-n1'></i> {item.alert}</div>
                                                                                <div className='d-flex align-items-center'>
                                                                                    {/* {pathname == "/atd/atd-home" && <div className='text-primary mr-1' role="button" onClick={() => this.viewDetailsAction(item)}>View Details</div>} */}
                                                                                    <div className='text-primary' role="button" onClick={() => this.alertAction(item)}> <i className='ti ti-x mr-0 mt-n1'></i></div>
                                                                                </div>
                                                                            </div>
                                                                        )}

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                            </>
                                        }
                                    </div>


                                    <div className="row">
                                        <div className="col-8">
                                            <div className="accordion" id="accordionExample">
                                                {accordionSections
                                                    .filter(section => section.title !== 'Notification') // Filter out notification sections
                                                    .map((section, index) => (
                                                        <div
                                                            key={section.id}
                                                            className={`card accordion-item ${section.view == 'Expanded' ? 'active' : ''}${section.visible ? '' : ' d-none'}`}
                                                        >
                                                            <h2 className="accordion-header">
                                                                <button
                                                                    type="button"
                                                                    className={`accordion-button ${section.view == 'Expanded' ? '' : 'collapsed'}`}
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target={`#accordion-${index}`}
                                                                    aria-expanded={section.view == 'Expanded'}
                                                                    aria-controls={`accordion-${index}`}
                                                                    onClick={() => {
                                                                        if (this.props.preSignInState && !this.props.preSignInState.tenantId) {
                                                                            // We are showing this warning when user has more than 1 [advertiser/agency] and unselected tenant
                                                                            message.warning('Please select a Tenant!')
                                                                        }
                                                                    }}
                                                                >
                                                                    {section.title}
                                                                </button>
                                                            </h2>

                                                            <div
                                                                id={`accordion-${index}`}
                                                                className={`accordion-collapse collapse ${section.view == 'Expanded' ? 'show' : ''}`}
                                                                aria-labelledby={`accordion-${index}`}
                                                                data-bs-parent="#accordionExample"
                                                            >
                                                                <div className="accordion-body">
                                                                    {this.renderAccordionContent(section)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>

                                        <div className="col-4">
                                            {/* Additional accordion content */}
                                            <div className="accordion" id="accordionWithIcon">
                                                <div className="card accordion-item active mb-2">
                                                    <h2 className="accordion-header d-flex align-items-center">
                                                        <button
                                                            type="button"
                                                            className="accordion-button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target="#accordionWithIcon-1"
                                                            aria-expanded={true}
                                                            onClick={() => {
                                                                if (this.props.preSignInState && !this.props.preSignInState.tenantId) {
                                                                    // We are showing this warning when user has more than 1 [advertiser/agency] and unselected tenant
                                                                    message.warning('Please select a Tenant!')
                                                                }
                                                            }}
                                                        >
                                                            Recent Activities
                                                        </button>
                                                    </h2>

                                                    <div
                                                        id="accordionWithIcon-1"
                                                        className="accordion-collapse collapse show"
                                                        aria-labelledby="accordionWithIcon-1"
                                                    >
                                                        <div className="accordion-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                                                            {/* <ul className="timeline pl-2">
                                                                {recentActivityData && recentActivityData.length > 0
                                                                    ? recentActivityData.map((item, key) => {
                                                                        try {
                                                                            const words = item.desc && item.desc.split(' ');

                                                                            // Bold the first word
                                                                            words[0] = <b>{words[0]}</b>;

                                                                            return (
                                                                                <li key={key} className="timeline-item pb-4">
                                                                                    <span className="timeline-indicator-advanced">
                                                                                        <i className="ti ti-check"></i>
                                                                                    </span>
                                                                                    <div className="">
                                                                                        <h6 className="mb-0" style={{ fontSize: 14 }}>
                                                                                            {words.map((word, index) =>
                                                                                                index !== 0 ? ' ' + word : word
                                                                                            )}
                                                                                        </h6>
                                                                                        <span className="text-muted" style={{ fontSize: 12 }}>{item.cDate}</span>
                                                                                    </div>
                                                                                </li>
                                                                            );
                                                                        } catch (err) {
                                                                            console.error('Error rendering activity:', err);
                                                                            return null;
                                                                        }
                                                                    })
                                                                    : <div style={{ fontFamily: 'Poppins', padding: 10 }}>No Data Available</div>}
                                                            </ul> */}
                                                            <ul className="timeline pl-2">
                                                                {recentActivityData && recentActivityData.length > 0
                                                                    ? recentActivityData.map((item, key) => {
                                                                        try {
                                                                            return (
                                                                                <li key={key} className="timeline-item pb-4">
                                                                                    <span className="timeline-indicator-advanced">
                                                                                        <i className="ti ti-check"></i>
                                                                                    </span>
                                                                                    <div className="">
                                                                                        <h6 className="mb-0" style={{ fontSize: 14 }} dangerouslySetInnerHTML={{ __html: item.desc }}></h6>
                                                                                        <span className="text-muted" style={{ fontSize: 12 }}>{item.cDate}</span>
                                                                                    </div>
                                                                                </li>
                                                                            );
                                                                        } catch (err) {
                                                                            console.error('Error rendering activity:', err);
                                                                            return null;
                                                                        }
                                                                    })
                                                                    : <div style={{ fontFamily: 'Poppins', padding: 10 }}>No Data Available</div>}
                                                            </ul>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </AuthenticationBody>
                }

            </React.Fragment>

        );
    }
}

export default compose(
    connect(
        state => ({
            getUserPermissionList: get(state, 'app.getUserPermissionList', []),
            preSignInResponseList: get(state, 'app.preSignInData.responseList', []),
            preSignInState: get(state, 'app.preSignInState', {}),
            userId: get(state, 'app.preSignInData.userId', ''),
            signInData: get(state, 'app.signInData', {}),
            configurationData: get(state, 'app.configurationData.responseList', []),
            tenantIdVerified: get(state, 'app.preSignInState.tenantId', ''),
            userIdVerified: get(state, 'app.preSignInData.userId', ''),
            authTokenVerified: get(state, 'app.signInData.authToken', ''),
        }),
        {
            getHomeScreenSigninAction,
            getSignInDataAction,
            dispatchPreSignInData,
            listAdvertiserAction,
            getPaymentRelatedAccessAction,
            getSubscribeTrialAction,
            getConfigurationDataAction,
            postRecchageSubscribeAction,
            getHomeRecentActivityAction,
            getHomeNotificationListAction,
            postHomeNotificationUpdateAction,
            getHomeRecommendListAction,
            getDataConfigAction,
            postHomeAccountPerformanceAction,
            postHomeCampaignPerformanceAction,
            getHomeAdvertiserListAction,
            getPreferenceListAllAction,
            getHomeDraftCampaignListAction,
            getReSignInDataAction,
            postTenantSupportedPaymentTypesAction,
            postTenantPaymentTypeAction,
            configAttributeAction,
            logoutAction,
            getUserProfileDetailsAction,
            postUserProfileDetailsAction,
            getTenantAccountAccessAction,
            postHomePreferenceAction,
            getDefaultPageAccess,
        }
    ),
    withStyles(styles)
)(SignIn);